import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useRef } from "react";
// import { Tooltip } from "react-tooltip";
import './LegalApp.css';
import Navbar from './Navbar';
import Footer from './Footer';
// import StarRating from './StarRating';
import RightUserRating from './RightUserRating';
import StrategyUserRating from './StrategyUserRating';
import InvestigationUserRating from './InvestigationUserRating';
import axios from 'axios';
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import * as pdfMake from 'pdfmake/build/pdfmake';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const printTableSection = (elementId) => {
  // Get the element to print
  const element = document.getElementById(elementId);
  const title = element.id;

  if (!element) {
    console.error("Element not found");
    return;
  }

  // Create a new window
  const printWindow = window.open('', '_blank');

  // Write the element's content to the new window
  printWindow.document.write(`
    <html>
      <head>
        <title>LegalApp</title>
        <style>
          /* Add any custom styles for printing */
          table {
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            border: 1px solid #000;
            padding: 8px;
            text-align: left;
          }
        </style>
      </head>
      <body>
        <h3 style="text-align: center; font-size: 24px; font-weight: bold; font-family: 'Roboto', sans-serif;">FIR analysed using LegalApp</h3>
        <div style="text-align: center">
          <span style="text-align: center; font-size: 20px; font-weight: bold; font-family: 'Roboto', sans-serif;">www.legalapp.in</span>
        </div>
        <br></br>
        <h3 style="text-align: center; font-size: 24px; font-weight: bold; font-family: 'Roboto', sans-serif;">${title}</h3>
        <div style="font-family: 'Roboto', sans-serif;">
        ${element.innerHTML}
        </div>
      </body>
    </html>
  `);

  // Close the document to ensure it's ready for printing
  printWindow.document.close();

  // Trigger the print dialog
  printWindow.print();
};

const TableSection = ({ children }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    // Scroll to left after short delay to allow rendering
    const timeout = setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.scrollLeft = 0;
      }
    }, 100); // 100ms is usually enough for render to complete

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="table-section" ref={containerRef}>
      {children}
    </div>
  );
};

const natureofInjuryKeyMappings = {
  involvesMentalCruelty: "Mental Cruelty",
  involvesMinorPhysicalInjury: "Physical Injury",
  involvesSeriousPhysicalInjury: "Serious Physical Injury",
  involvesDowryDemand: "Dowry Demand",
  involvesGivingOrTakingDowry: "Giving/Taking Dowry"
};

const corroboratingRecordsKepMappings = {
  involvesPhoneCall: "Phone Call",
  involvesEmail: "Email",
  involvesChat: "Chat Message",
  involvesLetter: "Letter",
  involvesBankTransaction: "Bank Transaction",
  medicalExaminationConducted: "Medical Examination",
}

const explainationKeys = new Set(['involvesPhoneCall', 'involvesEmail', 'involvesChat', 'involvesLetter', 'involvesBankTransaction']);

const ExplainConfirmationPopup = ({ isOpen, onClose, onConfirm }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm(); // Call the API function passed from parent
    setIsLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <h3>Get Explanation</h3>
        <p>Click Submit to see why this analysis was selected.</p>
        <div className="popup-buttons">
          <button onClick={onClose} className="cancel-button" disabled={isLoading}>Cancel</button>
          <button onClick={handleConfirm} className="submit-popup-button" disabled={isLoading}>
            {isLoading ? <div className="spinner"></div> : "Submit"}
          </button>
        </div>
        {isLoading && (
          <div style={{ textAlign: 'center', marginTop: '20px', fontWeight: 'bold' }}>
            Please wait. It may take about a minute to do the analysis.
          </div>
        )}
      </div>
    </div>
  );
};

const GetHelpConfirmationPopup = ({ isOpen, onClose, onConfirm }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm(); // Call the API function passed from parent
    setIsLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <h3>Have Questions?</h3>
        <p>Submit request to seek help.</p>
        <div className="popup-buttons">
          <button onClick={onClose} className="cancel-button" disabled={isLoading}>Cancel</button>
          <button onClick={handleConfirm} className="submit-popup-button" disabled={isLoading}>
            {isLoading ? <div className="spinner"></div> : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

const ExplanationPopup = ({ explaination, isExplainationOpen, onExplainationClose }) => {
  if (!isExplainationOpen) return null;
  //console.log("Explaination: " + explaination);

  var explanationText;
  if (typeof explaination === "object") {
    explanationText = explaination.explaination;
  } else {
    explanationText = explaination;
  }

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <h3>Explanation</h3>
        <div className="explain-popup-content" style={{ textAlign: 'justify' }}>
          {explanationText.split('\n').map((line, index) => (
            <span key={index}>
              {line}
              <br />
            </span>
          ))}
        </div>

        <div className="popup-buttons">
          <button onClick={onExplainationClose} className="submit-popup-button">Close</button>
        </div>
      </div>
    </div>
  );
};

export function generateRandomSentence() {
  const words = [
    'the', 'quick', 'brown', 'fox', 'jumps', 'over', 'lazy', 'dog',
    'hello', 'world', 'react', 'javascript', 'developer', 'computer',
    'science', 'programming', 'code', 'algorithm', 'data', 'structure',
    'web', 'application', 'interface', 'design', 'user', 'experience',
    'mobile', 'desktop', 'cloud', 'server', 'database', 'network',
    'security', 'performance', 'optimization', 'framework', 'library',
    'component', 'state', 'props', 'hooks', 'context', 'redux',
    'random', 'sentence', 'generator', 'function', 'utility', 'helper'
  ];

  const punctuation = ['.', '!', '?'];
  const minLength = 100;
  const maxLength = 200;

  let sentence = '';
  let currentLength = 0;

  while (currentLength < minLength) {
    // Capitalize first letter of first word
    if (sentence === '') {
      const word = words[Math.floor(Math.random() * words.length)];
      sentence += word.charAt(0).toUpperCase() + word.slice(1);
      currentLength += word.length;
    } else {
      // Add space between words
      sentence += ' ';
      currentLength += 1;

      // Add random word
      const word = words[Math.floor(Math.random() * words.length)];
      sentence += word;
      currentLength += word.length;
    }

    // Occasionally add punctuation and start new sentence
    if (Math.random() < 0.1 && currentLength < maxLength - 10) {
      const mark = punctuation[Math.floor(Math.random() * punctuation.length)];
      sentence += mark + ' ';
      currentLength += 2;

      // Start new sentence with capital
      const word = words[Math.floor(Math.random() * words.length)];
      sentence += word.charAt(0).toUpperCase() + word.slice(1);
      currentLength += word.length;
    }

    // Ensure we don't exceed max length
    if (currentLength >= maxLength) {
      // Add ending punctuation if needed
      if (!punctuation.includes(sentence.slice(-1))) {
        sentence += punctuation[Math.floor(Math.random() * punctuation.length)];
      }
      break;
    }
  }

  return sentence;
}

const FIRSections = ({ sections }) => {
  return (
    <TableSection title="">
      <div class="fir-table-container">
        <table className='fir-table'>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Section</th>
              <th>Act</th>
            </tr>
          </thead>
          <tbody>
            {sections.map((section, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{section.number}</td>
                <td>{section.act}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </TableSection>
  );
};

const FIROverview = ({ data }) => {
  return (
    <TableSection title="">
      <div class="fir-table-container">
        <table className='fir-table'>
          <thead>
            <tr>
              <th>Case Type</th>
              <th>Immediate Threat of Death or Grave Physical Injury</th>
              <th>Maximum Imprisonment (months)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{data.caseType?data.caseType:'Matrimonial'}</td>
              <td>{data.immediateThreat}</td>
              <td>{data.maxImprisonmentInMonths === 0 ? 'Will be determined based on the analysis of the allegations below.' : data.maxImprisonmentInMonths}</td>
              {/* <td>
                  {data.rawAllegations.split('\n').map((line, index) => (
                    <span key={index}>
                      {line}
                      <br />
                    </span>
                  ))}
                </td> */}
            </tr>
          </tbody>
        </table>
      </div>
    </TableSection>
  );
};

const ComplainantTable = ({ complainant }) => {
  return (
    <TableSection title="">
      <div class="fir-table-container">
        <table className="fir-table">
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Name</th>
              <th>Age</th>
              <th>Gender</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>{complainant.name}</td>
              <td>{complainant.age}</td>
              <td>{complainant.gender}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </TableSection>
  );
};

const AccusedTable = ({ accusedList }) => {
  return (
    <TableSection title="">
      <div class="fir-table-container">
        <table className="fir-table">
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Name</th>
              <th>Age</th>
              <th>Gender</th>
              <th>Is Alive</th>
              <th>Relationship with Complainant</th>
            </tr>
          </thead>
          <tbody>
            {accusedList.map((accused, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{accused.name}</td>
                <td>{accused.age}</td>
                <td>{accused.gender}</td>
                <td>{accused.deceased === "No" ? "Yes" : "No"}</td>
                <td>{accused.relationshipWithComplainant}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </TableSection>
  );
};

const AllegationsTable = ({ user, allegations }) => {
  const handlePrint = () => {
    printTableSection('Allegations'); // Pass the id of the element to print
  };

  const email = localStorage.getItem('email');

  return (
    <TableSection title="">
      <div id='Allegations'>
        <div hidden={email === 'demo@legalapp.in'} style={{ textAlign: 'justify', marginBottom: '10px', color: 'white', backgroundColor: '#094268', fontStyle: 'normal', padding: '5px', borderRadius: '5px', lineHeight: '1.4', marginBottom: '20px' }}>
          <strong>Note:</strong> In India's criminal justice system, mere allegations do not establish guilt. The registration of an FIR only initiates a formal investigation into the allegations—it does not imply guilt. The law presumes every accused person innocent unless the prosecution proves their guilt beyond reasonable doubt in court.
          {/* The burden of proof rests entirely on the prosecution, requiring irrefutable evidence to secure a conviction. */}
        </div>
        <div class="fir-table-container">
          <table className="fir-table">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Allegation</th>
                <th>Description</th>
                <th>Relevant Law</th>
                <th>Non-Bailable</th>
                <th>Cognizable</th>
                <th>Max Imprisonment (months)</th>
              </tr>
            </thead>
            <tbody>
              {allegations.map((allegation, index) => (
                <tr key={index} style={{ verticalAlign: 'top' }}>
                  <td>{index + 1}</td>
                  <td style={{ textAlign: "justify" }}>{allegation.allegationVerbatim}</td>
                  <td style={{ textAlign: "justify" }}>{allegation.allegationSummary}
                    {allegation.rank && (
                      <span style={{ display: 'block', marginTop: '10px', fontSize: '14px' }}>
                        <br></br>
                        <text style={{ color: '#f87c63', fontWeight: 'bold' }}>Seriousness Index: {allegation.rank}</text>

                        <br></br>
                        <text style={{ color: '#666666' }}>{allegation.rankReason}</text>
                      </span>
                    )}
                  </td>
                  <td style={{ textAlign: "justify", color: (user === 'Complainant' || user === 'Prosecution Counsel') && allegation.actAndSectionIncludedInFIR && allegation.actAndSectionIncludedInFIR.includes('No') ? 'red' : 'inherit' }}>
                    {allegation.actAndSection}
                    <br></br><br></br>
                    {allegation.actAndSectionIncludedInFIR && allegation.actAndSectionIncludedInFIR.includes('No') && (
                      <>
                        <span
                          // data-tooltip-id="tooltip-id"
                          // data-tooltip-content="Not registered in FIR"
                          style={{ fontSize: '14px', color: (user === 'Complainant' || user === 'Prosecution Counsel') && allegation.actAndSectionIncludedInFIR && allegation.actAndSectionIncludedInFIR.includes('No') ? 'red' : 'inherit' }}
                        >Note: This section is missing in the FIR.
                        </span>
                        {/* <Tooltip id="tooltip-id" place="top" /> */}
                      </>
                    )}
                  </td>
                  <td>{allegation.nonBailable}</td>
                  <td>{allegation.cognizable}</td>
                  <td>{allegation.maxImprisonmentInMonths}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </TableSection>
  );
};

const CorroborationsTable = ({ API_URL, id, allegations, user }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isExplainPopupOpen, setIsExplainPopupOpen] = useState(false);
  const [allegation, setAllegation] = useState(null);
  const [explainKey, setExplainKey] = useState(null);
  const [explanation, setExplanation] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const email = localStorage.getItem('email');

  const openPopup = (explainKey, allegation) => (e) => {
    e.preventDefault();
    //console.log('Explain key: ' + explainKey);
    //console.log('Allegation: ' + allegation.allegationSummary);
    if (allegation.explainations && allegation.explainations[explainKey]) {
      //console.log('Explaination found');
      setExplanation(allegation.explainations[explainKey]);
      setIsExplainPopupOpen(true);
    } else {
      //console.log('Get Explaination');
      setAllegation(allegation);
      setExplainKey(explainKey);
      setIsPopupOpen(true);
    }
  };

  const closeExplainPopup = () => setIsExplainPopupOpen(false);

  const closePopup = () => setIsPopupOpen(false);


  const fetchExplanation = async () => {
    if (!allegation || !explainKey) return;

    //console.log("Get explaination for: " + explainKey);
    var jwt = localStorage.getItem('jwtToken');

    const request = {
      id: id,
      allegationSummary: allegation.allegationSummary,
      analysisKeyName: explainKey
    }

    try {
      const response = await axios.post(API_URL + `/fir/explain/cr`, request, {
        headers: {
          'Content-Type': 'application/json', // Set the content type to JSON
          'Authorization': `Bearer ${jwt}`,
        },
      });
      //console.log(response.data);
      setExplanation(response.data.explaination);
      setIsPopupOpen(false);
      setIsExplainPopupOpen(true);
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage("An error occurred while processing the request. Please try again later.");
    } finally {
      setIsPopupOpen(false);
    }
  };

  return (
    <TableSection title="">
      <div hidden={user === 'Accused' || user === 'Defense Counsel' || email === 'demo@legalapp.in'} style={{ textAlign: 'justify', color: 'white', backgroundColor: '#094268', fontStyle: 'normal', padding: '5px', borderRadius: '5px', lineHeight: '1.4', marginBottom: '20px' }}>
        <strong>Note:</strong> Since the prosecution must prove the accused's guilt beyond reasonable doubt, if the FIR suffers from vague and sweeping allegations, inconsistencies and contradictions, missing information and supporting documents, it significantly weakens the case. To ensure a strong and credible case, it is imperative that the complainant provides the investigating officer with all relevant facts, material evidence, supporting documents, and a detailed list of witnesses to substantiate the allegations effectively.
      </div>
      <div hidden={user === 'Complainant' || user === 'Prosecution Counsel' || email === 'demo@legalapp.in'} style={{ textAlign: 'justify', color: 'white', backgroundColor: '#094268', fontStyle: 'normal', padding: '5px', borderRadius: '5px', lineHeight: '1.4', marginBottom: '20px' }}>
        <strong>Note:</strong> Since the prosecution must prove the accused's guilt beyond reasonable doubt, if there are vague and sweeping allegations, inconsistencies and contradictions, no witnesses, as well as missing information and supporting documents, it significantly weakens the prosecution's case. These deficiencies create reasonable doubt regarding the veracity of the allegations, making it difficult to establish a credible and coherent case against the accused.
      </div>
      <div class="fir-table-container">
        <table className="fir-table">
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Allegation</th>
              <th>Date, Time & Place</th>
              <th>Victims</th>
              <th>Accused</th>
              <th>Witnesses</th>
              <th
                className='tooltip-indicator'
                title='The allegation may need supporting records for verification. The complainant must provide these documents to substantiate the claim. Without them, the allegation may lack sufficient evidence.'>Supporting Record(s)</th>
              <th>Missing Information</th>
              <th>Inconsistencies & Contraditions</th>
              <th
                title='Sweeping allegations refers to general and broad accusations that lack specific details or evidence, often implying wrongdoing across a wide scope without concrete proof'
                className='tooltip-indicator'
              >
                Sweeping Allegation
              </th>
              <th title='Vague allegation is unclear or imprecise, lacking sufficient detail to be understood or acted upon' className='tooltip-indicator'>
                Vague Allegation</th>
            </tr>
          </thead>
          <tbody>
            {allegations.map((allegation, index) => (
              <tr key={index} style={{ verticalAlign: 'top' }}>
                <td>{index + 1}</td>
                <td style={{ textAlign: "justify" }}>
                  {allegation.allegationSummary}
                  <br /><br />
                  <b>Nature of Injury:</b>
                  <br />
                  {Object.keys(allegation)
                    .filter((key) => allegation[key] === "Yes" && natureofInjuryKeyMappings[key])
                    .map((key, index, arr) => {
                      //console.log(`Processing key: ${key}, Index: ${index}, Occurrences: ${arr.filter(k => k === key).length}`);
                      return (
                        <span key={`${key}-${index}`}>
                          {index + 1}. {natureofInjuryKeyMappings[key]}
                          <br /><br />
                        </span>
                      );
                    }) || "-"}
                </td>
                <td>
                  {(() => {
                    const entries = [];

                    if (allegation.dateOfOccurence) {
                      entries.push(<span>{allegation.dateOfOccurence}<br /></span>);
                    }

                    if (allegation.timeOfOccurence) {
                      entries.push(<span>{allegation.timeOfOccurence}<br /></span>);
                    }

                    if (allegation.placeOfOccurence) {
                      entries.push(<span>{allegation.placeOfOccurence}<br /></span>);
                    }

                    if (allegation.cityOfOccurence) {
                      entries.push(<span>{allegation.cityOfOccurence}<br /></span>);
                    }

                    if (allegation.countryOfOccurence) {
                      entries.push(<span>{allegation.countryOfOccurence}<br /></span>);
                    }
                    return entries.length > 0 ? entries : <span>-</span>;
                  })()}
                </td>
                <td>
                  {allegation.victims ? allegation.victims : 'Unkonwn'}
                </td>
                <td>
                  {allegation.accused ? allegation.accused : 'Unkonwn'}
                </td>
                <td>
                  {allegation.witnesses ? allegation.witnesses : '-'}
                </td>
                <td>
                  {Object.keys(allegation)
                    .filter((key) => allegation[key] === "Yes" && corroboratingRecordsKepMappings[key])
                    .map((key, index) => {
                      const isExplanationKey = explainationKeys.has(key); // Check if the key is in the Set
                      const content = corroboratingRecordsKepMappings[key]; // Get the content for the key

                      return (
                        <span key={key}>
                          {index + 1}.{" "}
                          {isExplanationKey ? (
                            <a href={key} target="_blank" rel="noopener noreferrer" onClick={(e) => {
                              e.preventDefault();
                              openPopup(key, allegation)(e);
                            }}>
                              {content}
                            </a>
                          ) : (
                            content
                          )}
                          <br /><br />
                        </span>
                      );
                    }) || "NA"}
                </td>
                <td style={{ textAlign: "justify" }}>
                  {(() => {
                    let index = 1;
                    const entries = [];

                    if (!allegation.dateOfOccurence) {
                      entries.push(<span key={index}>{index++}. Date<br /><br /></span>);
                    }
                    if (!allegation.timeOfOccurence) {
                      entries.push(<span key={index}>{index++}. Time<br /><br /></span>);
                    }
                    if (!allegation.placeOfOccurence) {
                      entries.push(<span key={index}>{index++}. Place<br /><br /></span>);
                    }
                    if (allegation.involvesDowryDemand === 'Yes' && (allegation.dowryAmountDemandedDisclosed === 'No' || !allegation.dowryAmountDemandedDisclosed) && (allegation.dowryArticlesDemandedDisclosed === 'No' || !allegation.dowryArticlesDemandedDisclosed)) {
                      entries.push(<span key={index}>{index++}. No specific details about the dowry demanded are provided.<br /><br /></span>);
                    }
                    if (allegation.involvesGivingOrTakingDowry === 'Yes' && allegation.dowryAmountGivenDisclosed === 'No' && allegation.dowryArticlesGivenDisclosed === 'No' && allegation.valueOfDowryGivenDisclosed === 'No') {
                      entries.push(<span key={index}>{index++}. No specific details about the dowry given/taken are provided.<br /><br /></span>);
                    }
                    if (allegation.involvesStridhan === 'Yes' && (allegation.valueOfStridhanDisclosed === 'No' || !allegation.valueOfStridhanDisclosed) && (allegation.stridhanArticlesDisclosed === 'No' || !allegation.stridhanArticlesDisclosed)) {
                      entries.push(<span key={index}>{index++}. No specific details about the Stridhan are provided.<br /><br /></span>);
                    }
                    if (allegation.involvesSeriousPhysicalInjury === 'Yes' && allegation.medicalExaminationConducted === 'No') {
                      entries.push(<span key={index}>{index++}. Medical examination for serious injury is not conducted.<br /><br /></span>);
                    }

                    return entries.length > 0 ? entries : <span>-</span>;
                  })()}
                </td>
                <td style={{ textAlign: "justify" }}>
                  {allegation.inconsistenciesAndContraditions ? allegation.inconsistenciesAndContraditions : '-'}
                </td>
                <td style={{ textAlign: "justify" }}>
                  {allegation.sweepingAllegation ? allegation.sweepingAllegation : '-'}
                  <br /><br />
                  {allegation.sweepingAllegation === 'Yes' && allegation.sweepingAllegationExplaination ? allegation.sweepingAllegationExplaination : ''}
                </td>
                <td style={{ textAlign: "justify" }}>
                  {allegation.vagueAllegation ? allegation.vagueAllegation : '-'}
                  <br /><br />
                  {allegation.vagueAllegation === 'Yes' && allegation.vagueAllegationExplaination ? allegation.vagueAllegationExplaination : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ExplainConfirmationPopup isOpen={isPopupOpen} onClose={closePopup} onConfirm={fetchExplanation} />
      <ExplanationPopup explaination={explanation} isExplainationOpen={isExplainPopupOpen} onExplainationClose={closeExplainPopup} />

      {errorMessage && (
        <div className="popup-overlay">
          <div className="error-popup" style={{ border: '3px solid white', backgroundColor: 'white', padding: '20px', borderRadius: '8px', textAlign: 'center', maxWidth: '400px', margin: '20px auto' }}>
            <div className="error-message" style={{ marginBottom: '15px', fontSize: '16px', color: '#333' }}>{errorMessage}</div>
            <button
              className="error-ok-button"
              onClick={() => setErrorMessage(null)}
              style={{ padding: '10px 20px', fontSize: '14px', color: 'white', backgroundColor: '#007bff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </TableSection>
  );
};

const RightsTable = ({ API_URL, id, bucketFileName, rights, rightToAllegationsMap, rightRatingMap, setRecheckPendingRatings }) => {
  const [showFAQPopup, setShowPopup] = useState(false);
  const [confirmGetHelpPopup, setConfirmGetHelpPopup] = useState(false);
  const [showGetHelpPopup, setShowGetHelpPopup] = useState(false);
  const [currentFAQ, setCurrentFAQ] = useState([]);
  const [getHelpRight, setGetHelpRight] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const openPopup = (faq) => {
    setCurrentFAQ(faq);
    setShowPopup(true);
  };

  const closeFAQPopup = () => {
    setShowPopup(false);
    setCurrentFAQ([]);
  };

  const openGetHelpPopup = (e) => (right) => {
    e.preventDefault();
    console.log('Get Help FIR: ' + id);
    console.log('Get Help Right: ' + right.id);

    setGetHelpRight(right);
    setConfirmGetHelpPopup(true);
  };

  const closeConfirmGetHelpPopup = () => {
    setConfirmGetHelpPopup(false);
  }

  const requestGetHelp = async () => {
    var jwt = localStorage.getItem('jwtToken');
    var email = localStorage.getItem('email');
    var user = localStorage.getItem('role');

    const request = {
      email: email,
      user: user,
      firId: id,
      bucketFileName: bucketFileName,
      rightId: getHelpRight.id,
      title: getHelpRight.title,
      description: getHelpRight.description,
      remedy: getHelpRight.remedy,
    }

    try {
      const response = await axios.post(API_URL + `/gethelp`, request, {
        headers: {
          'Content-Type': 'application/json', // Set the content type to JSON
          'Authorization': `Bearer ${jwt}`,
        },
      });

      console.log(response.data);
      setShowGetHelpPopup(true);
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage("An error occurred while processing the request. Please try again later.");
    } finally {
      setConfirmGetHelpPopup(false);
    }
  };

  const closeGetHelpCompletedPopup = (e) => {
    e.preventDefault();
    setShowGetHelpPopup(false);
  }

  return (
    <div>
      <TableSection title="">
        <div class="fir-table-container">
          <table className="fir-table">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Title</th>
                {/* <th>Applicable to Allegations</th> */}
                <th>Legal Provisions</th>
                <th>Description</th>
                <th>Remedy</th>
                <th>Judgments</th>
                {/* <th>Author</th> */}
              </tr>
            </thead>
            <tbody>
              {rights && rights
                .filter(right => right.title && right.title.trim() !== '') // Ensures right.title is not null
                .map((right, index) => (
                  <tr key={index} style={{ verticalAlign: 'top' }}>
                    <td>{index + 1}</td>
                    <td>
                      <b>{right.title}</b>
                      {/* <br /> <br />
                    {right.questionsAnswers && right.questionsAnswers.length > 0 && (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          openPopup(right.questionsAnswers);
                        }}
                      >
                        FAQ
                      </a>
                    )} */}
                    </td>
                    {/* <td>
                    {rightToAllegationsMap && rightToAllegationsMap[right.id]
                      ? rightToAllegationsMap[right.id].map((allegationIndex, index) => (
                        <span key={index}>
                          {parseInt(allegationIndex, 10) + 1}
                          {index < rightToAllegationsMap[right.id].length - 1 ? ", " : ""}
                        </span>
                      ))
                      : "N/A"
                    }
                  </td> */}
                    <td>
                      {right.legalProvisions && right.legalProvisions.length > 0 ? (
                        right.legalProvisions.map((provision, index) => (
                          <span key={index}>
                            Section {provision.section + " " + provision.act}
                            <br />
                            <br />
                          </span>
                        ))
                      ) : (
                        <span>-</span>
                      )}
                    </td>
                    <td style={{ textAlign: "justify" }}>
                      {
                        // right.description
                        right.description.split('\n').map((line, index) => (
                          <span key={index}>
                            {line}
                            <br />
                          </span>
                        ))
                      }
                      <br />
                      {right.questionsAnswers && right.questionsAnswers.length > 0 && (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            openPopup(right.questionsAnswers);
                          }}
                        >
                          Learn More
                        </a>
                      )}
                      <br /><br />
                      <div>
                        <button className='submit-button' onClick={(e) => openGetHelpPopup(e)(right)}>Get Help</button>
                      </div>

                      {/* <StarRating rating={5.00} reviewCount={8945} />
                    <br /> */}

                      {(localStorage.getItem('role') === 'admin' || (id !== '0dkuEsSZ1Hs9xIMjMqCf' && id !== 'y9z9xpAUJewPhl5JEfHD')) && (
                        <>
                          <br /><br /><br />
                          <RightUserRating
                            API_URL={API_URL}
                            id={id}
                            bucketFileName={bucketFileName}
                            right={right}
                            rightRatingMap={rightRatingMap}
                            setRecheckPendingRatings={setRecheckPendingRatings}
                          />
                          <br />
                          <br></br>
                        </>
                      )}
                    </td>
                    <td style={{ textAlign: "justify" }}>{right.remedy}</td>
                    <td style={{ textAlign: "justify" }}>
                      {right.citations && right.citations.map((judgment, index) => (
                        <span key={index}>
                          <b>{judgment.court}</b>
                          <br />
                          {judgment.title + " " + judgment.caseCitation}
                          <br />
                          {judgment.relevantText}
                          <br />
                          <br />
                        </span>
                      ))}
                    </td>
                    {/* <td>
                    {right.createdBy}
                    <br /><br />
                    <StarRating rating={4.95} reviewCount={49281} />
                    <br /><br />
                    <a href='#'>Consult</a>
                  </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <GetHelpConfirmationPopup isOpen={confirmGetHelpPopup} onClose={closeConfirmGetHelpPopup} onConfirm={requestGetHelp} />
      </TableSection>

      {showFAQPopup && (
        <div className="popup-overlay">
          <div className="popup-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <h3 style={{ "textAlign": "center" }}>Frequently Asked Questions</h3>
            <div style={{ flexGrow: '1', overflowY: 'auto' }}>
              <ul>
                {currentFAQ.map((faq, index) => (
                  <li key={index}>
                    <b>Q: {faq.question}</b>
                    <p>
                      {
                        faq.answer.split('\n').map((line, index) => (
                          <span key={index}>
                            {line}
                            <br />
                          </span>
                        ))
                      }
                    </p>
                  </li>
                ))}
              </ul>
            </div>

            <button onClick={closeFAQPopup} style={{ alignSelf: 'center', marginTop: '10px', padding: '10px 20px', borderRadius: '5px' }}>Close</button>
          </div>

        </div>
      )}

      {showGetHelpPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2>Request Submitted</h2>
            <p>We’ve received your request and our team will contact you via email shortly.</p>
            <div className="popup-buttons">
              <button
                className="submit-popup-button"
                onClick={(e) => closeGetHelpCompletedPopup(e)}
              >Close</button>
            </div>
          </div>
        </div>
      )}

      {errorMessage && (
        <div className="popup-overlay">
          <div className="error-popup" style={{ border: '3px solid white', backgroundColor: 'white', padding: '20px', borderRadius: '8px', textAlign: 'center', maxWidth: '400px', margin: '20px auto' }}>
            <div className="error-message" style={{ marginBottom: '15px', fontSize: '16px', color: '#333' }}>{errorMessage}</div>
            <button
              className="error-ok-button"
              onClick={() => setErrorMessage(null)}
              style={{ padding: '10px 20px', fontSize: '14px', color: 'white', backgroundColor: '#007bff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const FIRInvestigationTable = ({ API_URL, id, user, allegations, setRecheckPendingRatings, analyseInvestigationPointsForAllegation }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [confirmPoliceAppPopupOpen, setConfirmPoliceAppPopupOpen] = useState(false);
  const [confirmCourtAppPopupOpen, setConfirmCourtAppPopupOpen] = useState(false);
  const [uri, setUri] = useState(null);

  const email = localStorage.getItem('email');

  const openConfirmPoliceAppPopup = () => {
    setConfirmPoliceAppPopupOpen(true);
    setIsLoading(false);
    setUri('police');
  }

  const openConfirmCourtAppPopup = () => {
    setConfirmCourtAppPopupOpen(true);
    setIsLoading(false);
    setUri('court');
  }

  const onClose = () => {
    setConfirmPoliceAppPopupOpen(false);
    setConfirmCourtAppPopupOpen(false);
    setIsLoading(false);
    setUri(null);
  }

  const onConfirmApplication = async () => {
    setIsLoading(true);

    try {
      const jwt = localStorage.getItem('jwtToken');
      const response = await axios.get(API_URL + `/fir/download/pi/${uri}/${id}`, {
        headers: {
          'Authorization': `Bearer ${jwt}`,
        },
        responseType: 'blob', // Important: This tells axios to expect a binary file
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], { type: 'application/rtf' });

      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link to trigger the download
      const link = document.createElement('a');
      link.href = url;
      if (uri === 'police') {
        link.download = `PI_PoliceApplication_${id}.rtf`; // You can customize the file name here
      } else if (uri === 'court') {
        link.download = `PI_CourtApplication_${id}.rtf`; // You can customize the file name here
      }

      link.style.display = 'none'; // Hide the link

      // Add the link to the DOM, click it, and then remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Revoke the temporary URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading FIR:', error);
      setErrorMessage("An error occurred while downloading the FIR. Please try again later.");
    }
    finally {
      setIsLoading(false);
      setConfirmPoliceAppPopupOpen(false);
      setConfirmCourtAppPopupOpen(false);
      setUri(null);
    }
  };

  const [isAnalyseInvestigationPointsForAllegationLoading, setIsAnalyseInvestigationPointsForAllegationLoading] = useState(false);
  const [activeSpinnerIndex, setActiveSpinnerIndex] = useState(null);

  const handleTryAgain = async (index) => {
    setActiveSpinnerIndex(index);
    setIsAnalyseInvestigationPointsForAllegationLoading(true);
    analyseInvestigationPointsForAllegation(index)
      .then(() => {
        setIsAnalyseInvestigationPointsForAllegationLoading(false);
        setActiveSpinnerIndex(null);
        localStorage.removeItem('firList');
      })
      .catch((error) => {
        console.error("Error analyzing investigation points for allegation:", error);
        setErrorMessage("Error processing request. Please try again later.");
        setIsAnalyseInvestigationPointsForAllegationLoading(false);
        setActiveSpinnerIndex(null);
      });
  };

  const showcaseExaminationQuestionsForComplainant = [];
  const showcaseExaminationQuestionsForAccused = [];
  const [showcaseQuestions, setShowcaseQuestions] = useState([]);
  useEffect(() => {
    if (id === '9Kz9JEha6yARfSg99exq') {
      setShowcaseQuestions(showcaseExaminationQuestionsForAccused);
    } else if (id === 'gQeWSBDlgsC8Y48njpJW') {
      setShowcaseQuestions(showcaseExaminationQuestionsForComplainant);
    }
  }, [id]);

  return (
    <TableSection title="">
      <div hidden={user === 'Accused' || user === 'Defense Counsel' || email === 'demo@legalapp.in'} style={{ textAlign: 'justify', color: 'white', backgroundColor: '#094268', fontStyle: 'normal', padding: '5px', borderRadius: '5px', lineHeight: '1.4', marginBottom: '20px' }}>
        <strong>Note:</strong> In India's criminal justice system, the prosecution must prove the accused's guilt beyond reasonable doubt. Police cannot force the accused to confess to a crime or give evidence against themselves; however, if the accused voluntarily answers the investigative questions below, it may aid the police in assessing the truthfulness of the allegations.
      </div>
      <div hidden={user === 'Complainant' || user === 'Prosecution Counsel' || email === 'demo@legalapp.in'} style={{ textAlign: 'justify', color: 'white', backgroundColor: '#094268', fontStyle: 'normal', padding: '5px', borderRadius: '5px', lineHeight: '1.4', marginBottom: '20px' }}>
        <strong>Note:</strong> Under Sections 161 of the CrPC and 180 of the BNSS, the police examines the complainant and witnesses to verify the facts of the case, and the individuals being questioned are legally bound to answer all questions truthfully when interrogated by the authorities. The investigation questions below may assist the police in interrogating the complainant to determine the veracity of the allegations.
      </div>
      <div class="fir-table-container">
        <table className="fir-table">
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Allegation</th>
              <th>Examination Questions For {user === 'Accused' || user === 'Defense Counsel' ? 'Complainant' : "Accused"}</th>
            </tr>
          </thead>
          <tbody>
            {allegations && allegations
              .map((allegation, index) => (
                <tr key={index}>
                  <td style={{ textAlign: "justify", verticalAlign: "top", paddingTop: '25px' }}>{index + 1}</td>
                  <td style={{ textAlign: "justify", verticalAlign: "top", paddingTop: '25px' }}>
                    <span style={{
                      color: showcaseQuestions.includes(index + 1) ? 'red' : 'inherit',
                      fontWeight: showcaseQuestions.includes(index + 1) ? 'bold' : 'normal'
                    }}>
                      {allegation.allegationSummary}
                    </span>
                    {/* <ol style={{ paddingLeft: '15px' }}>
                      <li key={1} style={{ marginBottom: '15px' }}>
                        {allegation.allegationSummary}
                      </li>
                    </ol> */}
                  </td>
                  <td style={{ textAlign: "justify", verticalAlign: "top" }}>
                    {allegation.investigationQuestions && allegation.investigationQuestions.length > 0 ? (
                      <div>
                        <ol style={{ paddingLeft: '15px' }}>
                          {allegation.investigationQuestions.map((investigationQuestion, i) => (
                            <li key={i} style={{ marginBottom: '15px' }}>
                              <p style={{ color: investigationQuestion.topQuestion ? 'darkred' : 'inherit' }}>
                                <b>Question:</b> {investigationQuestion.question}
                              </p>
                              <p style={{ color: '#666666' }}>
                                <b>Reason:</b> {investigationQuestion.explanation}
                              </p>
                            </li>
                          ))}

                          {/* Blurred additional lines for sample FIR */}
                          {/* {localStorage.getItem('role') !== 'admin' && (id === '0dkuEsSZ1Hs9xIMjMqCf' || id === 'y9z9xpAUJewPhl5JEfHD') && (
                            <>
                              {[1, 2, 3].map((i) => (
                                <li key={`blurred-${i}`} style={{ marginBottom: '15px', filter: 'blur(4px)', userSelect: 'none' }}>
                                  <p>
                                    <b>Question:</b> {generateRandomSentence().slice(0, 60)}?
                                  </p>
                                  <p style={{ color: '#666666' }}>
                                    <b>Reason:</b> {generateRandomSentence().slice(0, 120)}
                                  </p>
                                </li>
                              ))}
                            </>
                          )} */}
                        </ol>

                        {(localStorage.getItem('role') === 'admin' || (id !== '0dkuEsSZ1Hs9xIMjMqCf' && id !== 'y9z9xpAUJewPhl5JEfHD')) && (
                          <>
                            <InvestigationUserRating
                              API_URL={API_URL}
                              id={id}
                              allegationSummary={allegation.allegationSummary}
                              ratingFor="Investigation Questions"
                              previousRating={allegation.investigationQuestionsRating}
                              setRecheckPendingRatings={setRecheckPendingRatings}
                            />
                          </>
                        )}
                      </div>

                    ) : (
                      <div>
                        <span>-</span>
                        <br></br><br></br>
                        <div>
                          <button
                            className='submit-button'
                            onClick={() => handleTryAgain(index)}
                            disabled={isAnalyseInvestigationPointsForAllegationLoading && activeSpinnerIndex !== index}
                          >{isAnalyseInvestigationPointsForAllegationLoading && activeSpinnerIndex === index ? <div className="spinner"></div> : 'Try Again'}
                          </button>
                        </div>
                        <br /><br /><br />
                      </div>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div 
        hidden={email === 'demo@legalapp.in' || localStorage.getItem('role') === 'police'} 
        style={{ textAlign: 'justify', color: 'white', backgroundColor: '#094268', fontStyle: 'normal', padding: '5px', borderRadius: '5px', lineHeight: '1.4', marginBottom: '20px' }}>
        {/* <strong>Note:</strong> The {user === 'Accused' || user === 'Defense Counsel' ? 'accused' : 'complainant'} has the legal right to a fair, impartial, and thorough investigation. If the investigation is lax, incomplete, or biased, an application to seek proper investigation can be filed before the Police Commissioner or Judicial Magistrate or both.<br />Click <a href='#' onClick={(e) => { e.preventDefault(); e.stopPropagation(); openConfirmPoliceAppPopup(); }} style={{ textDecoration: "underline", textUnderlineOffset: '3px', color: '#ffcc00' }}><span style={{ color: '#ffcc00' }}><strong>here</strong></span></a> to generate an Application to the Police Commissioner, or click <a href='#' onClick={(e) => { e.preventDefault(); e.stopPropagation(); openConfirmCourtAppPopup(); }} style={{ textDecoration: "underline", textUnderlineOffset: '3px', color: '#ffcc00' }}><span style={{ color: '#ffcc00' }}><strong>here</strong></span></a> to generate an Application to the Court for Proper Investigation based on the above investigation points. */}
        <strong>Note:</strong> The {user === 'Accused' || user === 'Defense Counsel' ? 'accused' : 'complainant'} has the legal right to a fair, impartial, and thorough investigation. An application to seek proper investigation can be filed before the Police Commissioner or Judicial Magistrate or both.<br />Click <a href='#' onClick={(e) => { e.preventDefault(); e.stopPropagation(); openConfirmPoliceAppPopup(); }} style={{ textDecoration: "underline", textUnderlineOffset: '3px', color: '#ffcc00' }}><span style={{ color: '#ffcc00' }}><strong>here</strong></span></a> to generate an Application to the Police Commissioner, or click <a href='#' onClick={(e) => { e.preventDefault(); e.stopPropagation(); openConfirmCourtAppPopup(); }} style={{ textDecoration: "underline", textUnderlineOffset: '3px', color: '#ffcc00' }}><span style={{ color: '#ffcc00' }}><strong>here</strong></span></a> to generate an Application to the Court for Proper Investigation based on the above investigation points.
      </div>

      {confirmPoliceAppPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h3>Generate Application</h3>
            <p>Click Submit to generate application to the Police Commissioner.</p>
            <div className="popup-buttons">
              <button onClick={onClose} className="cancel-button" disabled={isLoading}>Cancel</button>
              <button onClick={onConfirmApplication} className="submit-popup-button" disabled={isLoading}>
                {isLoading ? <div className="spinner"></div> : "Submit"}
              </button>
            </div>
            {isLoading && (
              <div style={{ textAlign: 'center', marginTop: '20px', fontWeight: 'bold' }}>
                Please wait. Depending on the case complexity, it may take a few minutes to generate the application.
              </div>
            )}
          </div>
        </div>
      )}

      {confirmCourtAppPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h3>Generate Application</h3>
            <p>Click Submit to generate application to the Court.</p>
            <div className="popup-buttons">
              <button onClick={onClose} className="cancel-button" disabled={isLoading}>Cancel</button>
              <button onClick={onConfirmApplication} className="submit-popup-button" disabled={isLoading}>
                {isLoading ? <div className="spinner"></div> : "Submit"}
              </button>
            </div>
            {isLoading && (
              <div style={{ textAlign: 'center', marginTop: '20px', fontWeight: 'bold' }}>
                Please wait. Depending on the case complexity, it may take a few minutes to generate the application.
              </div>
            )}
          </div>
        </div>
      )}

      {errorMessage && (
        <div className="popup-overlay">
          <div className="error-popup" style={{ border: '3px solid black', backgroundColor: 'white', padding: '20px', borderRadius: '8px', textAlign: 'center', maxWidth: '400px', margin: '20px auto' }}>
            <div className="error-message" style={{ marginBottom: '15px', fontSize: '16px', color: '#333' }}>{errorMessage}</div>
            <button
              className="error-ok-button"
              onClick={() => setErrorMessage(null)}
              style={{ padding: '10px 20px', fontSize: '14px', color: 'white', backgroundColor: '#007bff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </TableSection>
  );
};

const FIREvidenceMappingTable = ({ API_URL, id, user, allegations, setRecheckPendingRatings, analyseDefenseForAllegation }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [activeSpinnerIndex, setActiveSpinnerIndex] = useState(null);
  const email = localStorage.getItem('email');

  const handleTryAgain = async (index) => {
    setActiveSpinnerIndex(index);
    setIsLoading(true);
    analyseDefenseForAllegation(index)
      .then(() => {
        setIsLoading(false);
        setActiveSpinnerIndex(null);
        localStorage.removeItem('firList');
      })
      .catch((error) => {
        console.error("Error analyzing defense for allegation:", error);
        setErrorMessage("Error processing request. Please try again later.");
        setIsLoading(false);
        setActiveSpinnerIndex(null);
      });
  };

  const showcaseEvidenceForComplainant = [];
  const showcaseEvidenceForAccused = [];
  const [showcaseEvidences, setShowcaseEvidences] = useState([]);
  useEffect(() => {
    if (id === '9Kz9JEha6yARfSg99exq') {
      setShowcaseEvidences(showcaseEvidenceForComplainant);
    } else if (id === 'gQeWSBDlgsC8Y48njpJW') {
      setShowcaseEvidences(showcaseEvidenceForAccused);
    }
  }, [id]);

  return (
    <TableSection title="">
      <div hidden={user === 'Complainant' || user === 'Prosecution Counsel' || email === 'demo@legalapp.in'} style={{ textAlign: 'justify', color: 'white', backgroundColor: '#094268', fontStyle: 'normal', padding: '5px', borderRadius: '5px', lineHeight: '1.4', marginBottom: '20px' }}>
        <strong>Note:</strong> In India's criminal justice system, the burden of proof to secure a conviction in a criminal case rests entirely on the prosecution. The accused may choose to present evidence in their defense, though the law does not require them to do so.
      </div>
      <div hidden={user === 'Accused' || user === 'Defense Counsel' || email === 'demo@legalapp.in'} style={{ textAlign: 'justify', color: 'white', backgroundColor: '#094268', fontStyle: 'normal', padding: '5px', borderRadius: '5px', lineHeight: '1.4', marginBottom: '20px' }}>
        <strong>Note:</strong> In India's criminal justice system, the burden of proof lies entirely with the prosecution to secure a conviction, and if the evidence raises even the slightest doubt, courts are obligated to acquit the accused. To ensure a strong case, the complainant must provide the investigating officer with all relevant facts, material evidence, supporting documents, and a detailed list of witnesses to substantiate the allegations.
      </div>
      <div class="fir-table-container">
        <table className="fir-table">
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Allegation</th>
              <th>{user === 'Accused' || user === 'Defense Counsel' ? 'Defense Evidence' : "Prosecution Evidence"}</th>
            </tr>
          </thead>
          <tbody>
            {allegations && allegations
              .map((allegation, index) => (
                <tr key={index}>
                  <td style={{ textAlign: "justify", verticalAlign: "top", paddingTop: '25px' }}>{index + 1}</td>
                  <td style={{ textAlign: "justify", verticalAlign: "top", paddingTop: '25px' }}>
                    <span style={{
                      color: showcaseEvidences.includes(index + 1) ? 'red' : 'inherit',
                      fontWeight: showcaseEvidences.includes(index + 1) ? 'bold' : 'normal'
                    }}>
                      {allegation.allegationSummary}
                    </span>
                    {/* <ol style={{ paddingLeft: '15px' }}>
                      <li key={1} style={{ marginBottom: '15px' }}>
                        {allegation.allegationSummary}
                        <br></br>
                      </li>
                    </ol> */}
                  </td>

                  <td style={{ textAlign: "justify", verticalAlign: "top" }}>
                    {user === 'Accused' || user === 'Defense Counsel' ? (
                      allegation.defensePoints && allegation.defensePoints.length > 0 ? (
                        <div>
                          <ol style={{ paddingLeft: '15px' }}>
                            {allegation.defensePoints.map((defensePointObj, i) => (
                              <li key={i} style={{ marginBottom: '15px' }}>
                                <p style={{ color: defensePointObj.topEvidence ? 'darkred' : 'inherit' }}>
                                  <b>Defense Evidence:</b> {defensePointObj.defensePoint}
                                </p>
                                <p style={{ color: '#666666' }}>
                                  <b>Reason:</b> {defensePointObj.explanation}
                                </p>
                              </li>
                            ))}

                            {/* Blurred additional lines for sample FIR */}
                            {/* {localStorage.getItem('role') !== 'admin' && (id === '0dkuEsSZ1Hs9xIMjMqCf' || id === 'y9z9xpAUJewPhl5JEfHD') && (
                              <>
                                {[1, 2, 3].map((i) => (
                                  <li key={`blurred-${i}`} style={{ marginBottom: '15px', filter: 'blur(4px)', userSelect: 'none' }}>
                                    <p>
                                      <b>Defense Evidence:</b> {generateRandomSentence().slice(0, 60)}?
                                    </p>
                                    <p style={{ color: '#666666' }}>
                                      <b>Reason:</b> {generateRandomSentence().slice(0, 120)}
                                    </p>
                                  </li>
                                ))}
                              </>
                            )} */}
                          </ol>

                          {(localStorage.getItem('role') === 'admin' || (id !== '0dkuEsSZ1Hs9xIMjMqCf' && id !== 'y9z9xpAUJewPhl5JEfHD')) && (
                            <>
                              <InvestigationUserRating
                                API_URL={API_URL}
                                id={id}
                                allegationSummary={allegation.allegationSummary}
                                ratingFor="Defense Points"
                                previousRating={allegation.defensePointsRating}
                                setRecheckPendingRatings={setRecheckPendingRatings}
                              />
                            </>
                          )}
                        </div>
                      ) : (
                        <div>
                          <span>-</span>
                          <br></br><br></br>
                          <div>
                            <button
                              className='submit-button'
                              onClick={() => handleTryAgain(index)}
                              disabled={isLoading && activeSpinnerIndex !== index}
                            >{isLoading && activeSpinnerIndex === index ? <div className="spinner"></div> : 'Try Again'}
                            </button>
                          </div>
                          <br /><br /><br />
                        </div>
                      )
                    ) : allegation.prosecutionPoints && allegation.prosecutionPoints.length > 0 ? (
                      <div>
                        <ol style={{ paddingLeft: '15px' }}>
                          {allegation.prosecutionPoints.map((prosecutionPointObj, i) => (
                            <li key={i} style={{ marginBottom: '15px' }}>
                              <p style={{ color: prosecutionPointObj.topEvidence ? 'darkred' : 'inherit' }}>
                                <b>Supporting Evidence:</b> {prosecutionPointObj.prosecutionPoint}
                              </p>
                              <p style={{ color: '#666666' }}>
                                <b>Reason:</b> {prosecutionPointObj.explanation}
                              </p>
                            </li>
                          ))}

                          {/* Blurred additional lines for sample FIR */}
                          {/* {localStorage.getItem('role') !== 'admin' && (id === '0dkuEsSZ1Hs9xIMjMqCf' || id === 'y9z9xpAUJewPhl5JEfHD') && (
                            <>
                              {[1, 2, 3].map((i) => (
                                <li key={`blurred-${i}`} style={{ marginBottom: '15px', filter: 'blur(4px)', userSelect: 'none' }}>
                                  <p>
                                    <b>Supporting Evidence:</b> {generateRandomSentence().slice(0, 60)}?
                                  </p>
                                  <p style={{ color: '#666666' }}>
                                    <b>Reason:</b> {generateRandomSentence().slice(0, 120)}
                                  </p>
                                </li>
                              ))}
                            </>
                          )} */}
                        </ol>

                        {(localStorage.getItem('role') === 'admin' || (id !== '0dkuEsSZ1Hs9xIMjMqCf' && id !== 'y9z9xpAUJewPhl5JEfHD')) && (
                          <>
                            <InvestigationUserRating
                              API_URL={API_URL}
                              id={id}
                              allegationSummary={allegation.allegationSummary}
                              ratingFor="Prosecution Points"
                              previousRating={allegation.prosecutionPointsRating}
                              setRecheckPendingRatings={setRecheckPendingRatings}
                            />
                          </>
                        )}
                      </div>
                    ) : (
                      <div>
                        <span>-</span>
                        <br></br><br></br>
                        <div>
                          <button
                            className='submit-button'
                            onClick={() => handleTryAgain(index)}
                            disabled={isLoading && activeSpinnerIndex !== index}
                          >{isLoading && activeSpinnerIndex === index ? <div className="spinner"></div> : 'Try Again'}
                          </button>
                        </div>
                        <br /><br /><br />
                      </div>
                    )}
                  </td>

                </tr>
              ))}
          </tbody>
        </table>
        {errorMessage && (
          <div className="popup-overlay">
            <div className="error-popup" style={{ border: '3px solid black', backgroundColor: 'white', padding: '20px', borderRadius: '8px', textAlign: 'center', maxWidth: '400px', margin: '20px auto' }}>
              <div className="error-message" style={{ marginBottom: '15px', fontSize: '16px', color: '#333' }}>{errorMessage}</div>
              <button
                className="error-ok-button"
                onClick={() => setErrorMessage(null)}
                style={{ padding: '10px 20px', fontSize: '14px', color: 'white', backgroundColor: '#007bff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
              > OK
              </button>
            </div>
          </div>
        )}
      </div>
    </TableSection>
  );
};

const StrategyTable = ({ API_URL, id, bucketFileName, strategies, strategyToAllegationsMap, strategyRatingMap, setRecheckPendingRatings }) => {
  const [showFAQPopup, setShowPopup] = useState(false);
  const [confirmGetHelpPopup, setConfirmGetHelpPopup] = useState(false);
  const [showGetHelpPopup, setShowGetHelpPopup] = useState(false);
  const [currentFAQ, setCurrentFAQ] = useState([]);
  const [getHelpStrategy, setGetHelpStrategy] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const openPopup = (faq) => {
    setCurrentFAQ(faq);
    setShowPopup(true);
  };

  const closeFAQPopup = () => {
    setShowPopup(false);
    setCurrentFAQ([]);
  };

  const openGetHelpPopup = (e) => (strategy) => {
    e.preventDefault();
    console.log('Get Help FIR: ' + id);
    console.log('Get Help Strategy: ' + strategy.id);

    setGetHelpStrategy(strategy);
    setConfirmGetHelpPopup(true);
  };

  const closeConfirmGetHelpPopup = () => {
    setConfirmGetHelpPopup(false);
  }

  const requestGetHelp = async () => {
    var jwt = localStorage.getItem('jwtToken');
    var email = localStorage.getItem('email');
    var user = localStorage.getItem('role');

    const request = {
      email: email,
      user: user,
      firId: id,
      bucketFileName: bucketFileName,
      strategyId: getHelpStrategy.id,
      title: getHelpStrategy.title,
      description: getHelpStrategy.description,
    }

    try {
      const response = await axios.post(API_URL + `/gethelp`, request, {
        headers: {
          'Content-Type': 'application/json', // Set the content type to JSON
          'Authorization': `Bearer ${jwt}`,
        },
      });

      console.log(response.data);
      setShowGetHelpPopup(true);
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage("An error occurred while processing the request. Please try again later.");
    } finally {
      setConfirmGetHelpPopup(false);
    }
  };

  const closeGetHelpCompletedPopup = (e) => {
    e.preventDefault();
    setShowGetHelpPopup(false);
  }

  const titleOrder = [
    "Attempt Mediation",
    "Seek Anticipatory Bail",
    "Seek Proper Investigation",
    "Disprove Allegations",
    "Seek Quashing"
  ];

  return (
    <div>
      <TableSection title="">
        <div class="fir-table-container">
          <table className="fir-table">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Title</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {strategies && strategies
                .filter(strategy => strategy.title && strategy.title.trim() !== '')
                .sort((a, b) => {
                  const indexA = titleOrder.indexOf(a.title);
                  const indexB = titleOrder.indexOf(b.title);
                  // Handle titles not in the order list by putting them at the end
                  if (indexA === -1) return 1;
                  if (indexB === -1) return -1;
                  return indexA - indexB;
                })
                .map((strategy, index) => (
                  <tr key={index} style={{ verticalAlign: 'top' }}>
                    <td>{index + 1}</td>
                    <td>
                      <b>{strategy.title}</b>
                    </td>
                    <td style={{ textAlign: "justify" }}>
                      {
                        strategy.description.split('\n').map((line, index) => (
                          <span key={index}>
                            {line}
                            <br />
                          </span>
                        ))
                      }
                      <br />
                      {strategy.questionsAnswers && strategy.questionsAnswers.length > 0 && (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            openPopup(strategy.questionsAnswers);
                          }}
                        >
                          Learn More
                        </a>
                      )}
                      <br /><br />
                      <div>
                        <button className='submit-button' onClick={(e) => openGetHelpPopup(e)(strategy)}>Get Help</button>
                      </div>
                      <br /><br /><br />

                      {(localStorage.getItem('role') === 'admin' || (id !== '0dkuEsSZ1Hs9xIMjMqCf' && id !== 'y9z9xpAUJewPhl5JEfHD')) && (
                        <>
                          <StrategyUserRating
                            API_URL={API_URL}
                            id={id}
                            bucketFileName={bucketFileName}
                            strategy={strategy}
                            strategyRatingMap={strategyRatingMap}
                            setRecheckPendingRatings={setRecheckPendingRatings}
                          />
                        </>
                      )}
                      <br />
                      <br></br>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <GetHelpConfirmationPopup isOpen={confirmGetHelpPopup} onClose={closeConfirmGetHelpPopup} onConfirm={requestGetHelp} />
      </TableSection>

      {showFAQPopup && (
        <div className="popup-overlay">
          <div className="popup-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <h3 style={{ "textAlign": "center" }}>Frequently Asked Questions</h3>
            <div style={{ flexGrow: '1', overflowY: 'auto' }}>
              <ul>
                {currentFAQ.map((faq, index) => (
                  <li key={index}>
                    <b>Q: {faq.question}</b>
                    <p>
                      {
                        faq.answer.split('\n').map((line, index) => (
                          <span key={index}>
                            {line}
                            <br />
                          </span>
                        ))
                      }
                    </p>
                  </li>
                ))}
              </ul>
            </div>

            <button onClick={closeFAQPopup} style={{ alignSelf: 'center', marginTop: '10px', padding: '10px 20px', borderRadius: '5px' }}>Close</button>
          </div>

        </div>
      )}

      {showGetHelpPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2>Request Submitted</h2>
            <p>We’ve received your request and our team will contact you via email shortly.</p>
            <div className="popup-buttons">
              <button
                className="submit-popup-button"
                onClick={(e) => closeGetHelpCompletedPopup(e)}
              >Close</button>
            </div>
          </div>
        </div>
      )}

      {errorMessage && (
        <div className="popup-overlay">
          <div className="error-popup" style={{ border: '3px solid black', backgroundColor: 'white', padding: '20px', borderRadius: '8px', textAlign: 'center', maxWidth: '400px', margin: '20px auto' }}>
            <div className="error-message" style={{ marginBottom: '15px', fontSize: '16px', color: '#333' }}>{errorMessage}</div>
            <button
              className="error-ok-button"
              onClick={() => setErrorMessage(null)}
              style={{ padding: '10px 20px', fontSize: '14px', color: 'white', backgroundColor: '#007bff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const InterrogationTable = ({ interrogationList }) => {
  const [allegationExplanation, setAllegationExplanation] = useState(null);
  const [witnessExplanation, setWitnessExplanation] = useState(null);
  const [evidenceExplanation, setEvidenceExplanation] = useState(null);
  const [statement, setStatement] = useState(null);

  return (
    <TableSection title="">
      <div className="fir-table-container">
        <table className="fir-table">
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Name & Particulars</th>
              <th>Litigant/Witness</th>
              <th>Analysis</th>
            </tr>
          </thead>
          <tbody>
            {interrogationList.map((interrogation, index) => (
              <tr key={index}>
                <td style={{ textAlign: "justify", verticalAlign: "top" }}>{index + 1}</td>
                <td style={{ textAlign: "left", verticalAlign: "top" }}>
                  {interrogation.respondent}
                  {interrogation.ofWitness === "Yes" && (
                    <div>
                      <br></br><br></br>
                      <div>Relationship with Complainant: {interrogation.relationshipWithComplainant}</div>
                      <br></br>
                      <div>Relationship with Accused: {interrogation.relationshipWithAccused}</div>
                    </div>
                  )}
                  <br></br><br></br>
                  Interrogation Date: {interrogation.interrogationDate &&
                    `${interrogation.interrogationDate.slice(0, 2)}/${interrogation.interrogationDate.slice(2, 4)}/${interrogation.interrogationDate.slice(4)}`}
                  <br></br><br></br>
                  <button
                    className='submit-button'
                    style={{ marginLeft: 'auto', backgroundColor: '#FFFFFF', color: '#094268', fontWeight: 'bold', border: '1px solid #094268' }}
                    onClick={() => setStatement(interrogation.text)}>
                    View Statement
                  </button>
                </td>
                <td style={{ textAlign: "left", verticalAlign: "top" }}>
                  {interrogation.ofLitigant === "Yes" &&
                    interrogation.from?.includes("Complainant") &&
                    "Complainant"}
                  {interrogation.ofLitigant === "Yes" &&
                    interrogation.from?.includes("Accused") &&
                    "Accused"}
                  {interrogation.ofWitness === "Yes" &&
                    interrogation.ofEyewitness === "No" &&
                    "Witness"}
                  {interrogation.ofEyewitness === "Yes" && "Eyewitness"}
                  <br></br><br></br>
                  {interrogation.ofWitness === "Yes" && (
                    <div>
                      Cited in FIR:{" "}
                      <span
                        style={{
                          color: interrogation.witnessMentionedInFIR === "No" ? "red" : "inherit",
                          fontWeight: interrogation.witnessMentionedInFIR === "No" ? "600" : "normal",
                        }}
                      >
                        {interrogation.witnessMentionedInFIR}
                      </span>
                    </div>
                  )}
                  <br></br><br></br>
                  {/* {interrogation.ofWitness === "Yes" && (
                    <div>
                      Cited in Testimonies:{" "}
                      <span
                        style={{
                          color: interrogation.witnessMentionedInTestimony ? "inherit" : "red",
                          fontWeight: interrogation.witnessMentionedInTestimony ? "normal" : "600",
                        }}
                      >
                        {interrogation.witnessMentionedInTestimony ? "Yes" : "No"}
                      </span>
                    </div>
                  )} */}
                  {interrogation.ofWitness === "Yes" && (
                    <div>
                      Cited in Testimony:{" "}
                      {Array.isArray(interrogation.witnessMentionedInTestimony) &&
                        interrogation.witnessMentionedInTestimony.length > 0 ? (
                        <select
                          className="upload-select"
                          defaultValue=""
                          style={{
                            width: "15ch",
                            color: "grey",
                          }}
                        >
                          {interrogation.witnessMentionedInTestimony.map((t, idx) => (
                            <option key={`testimony-${idx}`} value={t}>
                              {t}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span
                          style={{
                            color: "red",
                            fontWeight: "600",
                          }}
                        >
                          No
                        </span>
                      )}
                    </div>
                  )}

                </td>
                <td style={{ textAlign: "justify" }}>
                  {interrogation.statementSummary}
                  {(interrogation.interrogationQA ?? []).map((qa, qaIdx) => (
                    <div key={qaIdx} className="qa-block">
                      {/* Simple fields */}
                      <b>Statement/Response: {qaIdx + 1}</b>
                      {qa.inconsistentWithFIR === "Yes" && (
                        <div className="qa-row">
                          <strong>Inconsistent with FIR:</strong> {qa.inconsistentWithFIRExplanation}
                        </div>
                      )}
                      {qa.crucialOmissions && qa.crucialOmissions !== 'No omission' && (
                        <div className="qa-row">
                          <strong>Crucial Omissions:</strong> {qa.crucialOmissions}
                        </div>
                      )}
                      {qa.inconsistentStatement && qa.inconsistentStatement === 'Yes' && (
                        <div className="qa-row">
                          <strong>Inconsistent Statement:</strong> {qa.inconsistentStatementExplanation}
                        </div>
                      )}
                      {qa.contradictingStatement && qa.contradictingStatement === 'Yes' && (
                        <div className="qa-row">
                          <strong>Contradicting Statement:</strong> {qa.contradictingStatementExplanation}
                        </div>
                      )}
                      {/* Relevant Allegations (keys only) */}
                      {qa.relevantAllegationsWithExplanation &&
                        Object.keys(qa.relevantAllegationsWithExplanation).length > 0 && (() => {
                          const allegationKeys = Object.keys(qa.relevantAllegationsWithExplanation);
                          return (
                            <div className="qa-row">
                              <strong>Relevant Allegations:</strong>{" "}
                              <select
                                className="upload-select"
                                defaultValue=""
                                aria-label="Relevant Allegations disclosed"
                                style={{
                                  width: "50ch",
                                  color: "grey"
                                }}
                                onChange={(e) => {
                                  const key = e.target.value;
                                  if (!key) return;
                                  const explanation = qa.relevantAllegationsWithExplanation?.[key];
                                  // store structured data; avoid HTML in state
                                  setAllegationExplanation({ key, explanation: explanation ?? "" });
                                  // make the selected text black
                                  e.target.style.color = "#000";
                                }}
                              >
                                <option value="" disabled>
                                  {`Select`}
                                </option>
                                {allegationKeys.map((k) => (
                                  <option key={`relAlg-${qaIdx}-${k}`} value={k}>
                                    {k}
                                  </option>
                                ))}
                              </select>
                            </div>
                          );
                        })()}

                      {/* New Allegations (list of { allegationSummary, allegationVerbatim }) */}
                      {Array.isArray(qa.allegations) && qa.allegations.length > 0 && (
                        <div className="qa-row">
                          <strong>New Allegations:</strong>{" "}
                          <select
                            className="upload-select"
                            defaultValue=""
                            aria-label="New Allegations"
                            style={{ width: "50ch", color: "grey" }}
                            onChange={(e) => {
                              const idx = e.target.value;
                              if (idx === "") return;
                              const sel = qa.allegations[Number(idx)];
                              const key = sel?.allegationSummary ?? "New Allegation";
                              const explanation = sel?.allegationVerbatim ?? "";
                              setAllegationExplanation({ key, explanation });
                              e.target.style.color = "#000";
                            }}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            {qa.newAllegations.map((a, idx) => (
                              <option key={`newAlg-${qaIdx}-${idx}`} value={idx}>
                                {a?.allegationSummary || `Allegation ${idx + 1}`}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      {/* Witnesses (keys only) */}
                      {qa.witnessesDisclosedWithExplanation &&
                        Object.keys(qa.witnessesDisclosedWithExplanation).length > 0 && (() => {
                          const witnessKeys = Object.keys(qa.witnessesDisclosedWithExplanation);
                          return (
                            <div className="qa-row">
                              <strong>Witnesses:</strong>{" "}
                              <select
                                className="upload-select"
                                defaultValue=""
                                aria-label="Witnesses disclosed"
                                style={{
                                  width: "50ch",
                                  color: "grey"
                                }}
                                onChange={(e) => {
                                  const key = e.target.value;
                                  if (!key) return;
                                  const explanation = qa.witnessesDisclosedWithExplanation?.[key];
                                  // store structured data; avoid HTML in state
                                  setWitnessExplanation({ key, explanation: explanation ?? "" });
                                  // make the selected text black
                                  e.target.style.color = "#000";
                                }}
                              >
                                <option value="" disabled>
                                  {`Select`}
                                </option>
                                {witnessKeys.map((k) => (
                                  <option key={`wit-${qaIdx}-${k}`} value={k}>
                                    {k}
                                  </option>
                                ))}
                              </select>
                            </div>
                          );
                        })()}
                      {/* Evidences (keys only) */}
                      {qa.evidencesDisclosedWithExplanation &&
                        Object.keys(qa.evidencesDisclosedWithExplanation).length > 0 && (() => {
                          const evidenceKeys = Object.keys(qa.evidencesDisclosedWithExplanation);
                          return (
                            <div className="qa-row">
                              <strong>Evidences:</strong>{" "}
                              <select
                                className="upload-select"
                                defaultValue=""
                                aria-label="Evidences disclosed"
                                style={{
                                  width: "50ch",
                                  color: "grey"
                                }}
                                onChange={(e) => {
                                  const key = e.target.value;
                                  if (!key) return;
                                  const explanation = qa.evidencesDisclosedWithExplanation?.[key];
                                  // store structured data; avoid HTML in state
                                  setEvidenceExplanation({ key, explanation: explanation ?? "" });
                                  // make the selected text black
                                  e.target.style.color = "#000";
                                }}
                              >
                                <option value="" disabled>
                                  {`Select`}
                                </option>
                                {evidenceKeys.map((k) => (
                                  <option key={`ev-${qaIdx}-${k}`} value={k}>
                                    {k}
                                  </option>
                                ))}
                              </select>
                            </div>
                          );
                        })()}

                    </div>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {statement && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h3>Statement</h3>
              <div style={{ fontSize: '16px', alignContent: 'justify', alignItems: 'justify', textAlign: 'justify', maxHeight: '50vh', overflowY: 'auto', marginBottom: '16px' }}>
                <p>{statement.split('\n').map((line, index) => (
                  <span key={index}>
                    {line}
                    <br />
                  </span>
                ))}</p>
              </div>
              <div className="popup-buttons">
                <button
                  className="submit-popup-button"
                  onClick={() => {
                    setStatement(null);
                  }
                  }>Close</button>
              </div>
            </div>
          </div>
        )}

        {allegationExplanation && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Allegations Details</h2>
              <p style={{ marginTop: 0, textAlign: "justify" }}>{allegationExplanation.key}</p>
              <p style={{ whiteSpace: "pre-wrap", textAlign: "justify" }}>
                {allegationExplanation.explanation || "No details provided."}
              </p>
              <div className="popup-buttons">
                <button
                  className="submit-popup-button"
                  onClick={() => setAllegationExplanation(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {witnessExplanation && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Witness Details</h2>
              <p style={{ marginTop: 0, textAlign: "justify" }}>{witnessExplanation.key}</p>
              <p style={{ whiteSpace: "pre-wrap", textAlign: "justify" }}>
                {witnessExplanation.explanation || "No details provided."}
              </p>
              <div className="popup-buttons">
                <button
                  className="submit-popup-button"
                  onClick={() => setWitnessExplanation(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {evidenceExplanation && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Evidence Details</h2>
              <p style={{ marginTop: 0, textAlign: "justify" }}>{evidenceExplanation.key}</p>
              <p style={{ whiteSpace: "pre-wrap", textAlign: "justify" }}>
                {evidenceExplanation.explanation || "No details provided."}
              </p>
              <div className="popup-buttons">
                <button
                  className="submit-popup-button"
                  onClick={() => setEvidenceExplanation(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </TableSection>
  );
};

// const AllegationCorroborationTable = ({ corroboratedAllegations, uncorroboratedAllegations }) => {
//   const [witnesses, setWitnesses] = useState(null);

//   // Normalize: support either Map<string, string[]> or plain object
//   const isMap = corroboratedAllegations instanceof Map;
//   const corroboratedKeys = isMap
//     ? Array.from(corroboratedAllegations.keys())
//     : Object.keys(corroboratedAllegations || {});

//   const handleCorroboratedSelect = (e) => {
//     e.target.style.color = "#000";
//     const allegation = e.target.value;
//     if (!allegation) return;

//     const names = isMap
//       ? (corroboratedAllegations.get(allegation) || [])
//       : (corroboratedAllegations?.[allegation] || []);

//     setWitnesses({
//       key: allegation,
//       explanation: names.length
//         ? `Witness:\n${names.map((n) => `• ${n}`).join("\n")}`
//         : "No corroborators listed.",
//     });

//     //e.target.selectedIndex = 0; // reset to placeholder
//   };

//   const handleUncorroboratedSelect = (e) => {
//     e.target.style.color = "#000";
//     const allegation = e.target.value;
//     if (!allegation) return;

//     setWitnesses({
//       key: allegation,
//       //explanation: `"${allegation}" is currently uncorroborated.`,
//     });

//     //e.target.selectedIndex = 0; // reset to placeholder
//   };

//   return (
//     <TableSection title="">
//       <div className="fir-table-container">
//         <table className="fir-table">
//           <thead>
//             <tr>
//               <th>Corroborated Allegations:</th>
//               <th>Uncorroborated Allegations:</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>
//                 <select
//                   defaultValue=""
//                   onChange={handleCorroboratedSelect}
//                   className="upload-select"
//                   style={{
//                     width: "75ch",
//                     color: "grey"
//                   }}
//                 >
//                   <option value="" disabled>
//                     Select
//                   </option>
//                   {corroboratedKeys.map((key) => (
//                     <option key={key} value={key}>
//                       {key}
//                     </option>
//                   ))}
//                 </select>
//               </td>
//               <td>
//                 <select
//                   defaultValue=""
//                   onChange={handleUncorroboratedSelect}
//                   className="upload-select"
//                   style={{
//                     width: "75ch",
//                     color: "grey"
//                   }}
//                 >
//                   <option value="" disabled>
//                     Select
//                   </option>
//                   {(uncorroboratedAllegations || []).map((allegation, idx) => (
//                     <option key={`${allegation}-${idx}`} value={allegation}>
//                       {allegation}
//                     </option>
//                   ))}
//                 </select>
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* Modal Popup */}
//       {witnesses && (
//         <div className="popup-overlay">
//           <div className="popup-container">
//             <h2>Allegation</h2>
//             <p style={{ marginTop: 0, textAlign: "justify" }}>{witnesses.key}</p>
//             <p style={{ whiteSpace: "pre-wrap", textAlign: "justify" }}>
//               {witnesses.explanation || ""}
//             </p>
//             <div className="popup-buttons">
//               <button
//                 className="submit-popup-button"
//                 onClick={() => setWitnesses(null)}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </TableSection>
//   );
// };

const AllegationCorroborationTable = ({
  allegations,
  corroboratedAllegations,
  uncorroboratedAllegations,
}) => {
  // Build lookup: verbatim -> { summary, sections[] }
  const lookup = React.useMemo(() => {
    const map = {};
    (allegations || []).forEach((a = {}) => {
      const {
        allegationVerbatim,
        allegationSummary,
        actAndSection,
      } = a;

      // normalize to array of non-empty strings
      const sections = Array.isArray(actAndSection)
        ? actAndSection.filter(Boolean)
        : actAndSection
          ? [actAndSection]
          : [];

      if (allegationVerbatim) {
        map[allegationVerbatim] = {
          summary: allegationSummary || allegationVerbatim,
          sections,
        };
      }
    });
    return map;
  }, [allegations]);

  // Flatten rows with serial numbers
  let serial = 1;

const renderSectionsCell = (sections = []) =>
  sections.length > 0 ? (
    <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
      {sections.map((s, i) => (
        <li key={i} style={{ margin: 0 }}>{s}</li>
      ))}
    </ul>
  ) : (
    '-'
  );

  return (
    <TableSection title="">
      <div className="fir-table-container">
        <table className="fir-table">
          {/* Control widths */}
          <colgroup>
            <col style={{ width: '5%' }} /> {/* Serial no */}
            <col /> {/* Allegation */}
            <col style={{ minWidth: '18vw' }} /> {/* Relevant Section */}
            <col style={{ minWidth: '30vw' }} /> {/* Corroborated By */}
          </colgroup>

          <thead>
            <tr>
              <th>S. No.</th>
              <th>Allegation</th>
              <th>Relevant Section</th>
              <th>Corroborated By</th>
            </tr>
          </thead>
          <tbody>
            {/* Corroborated allegations */}
            {Object.entries(corroboratedAllegations || {}).map(
              ([allegationVerbatim, names]) => {
                const entry = lookup[allegationVerbatim] || {};
                const summary = entry.summary || allegationVerbatim;
                const sections = entry.sections || [];
                const safeNames = Array.isArray(names) ? names : [];

                return (
                  <tr key={`corr-${allegationVerbatim}`}>
                    <td>{serial++}</td>
                    <td>{summary}</td>
                    <td>{renderSectionsCell(sections)}</td>
                    <td>
                      {safeNames.length > 0 ? (
                        <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                          {safeNames.map((name, idx) => (
                            <li key={idx}>{name}</li>
                          ))}
                        </ul>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                );
              }
            )}

            {/* Uncorroborated allegations */}
            {(uncorroboratedAllegations || []).map(
              (allegationVerbatim, idx) => {
                const entry = lookup[allegationVerbatim] || {};
                const summary = entry.summary || allegationVerbatim;
                const sections = entry.sections || [];

                return (
                  <tr key={`uncorr-${idx}`}>
                    <td>{serial++}</td>
                    <td>{summary}</td>
                    <td>{renderSectionsCell(sections)}</td>
                    <td>-</td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </div>
    </TableSection>
  );
};



const FIR = ({ API_URL }) => {
  const location = useLocation();
  const navigate = useNavigate();
  // const pdfRef = useRef();

  const { data } = location.state || { data: {} };

  const isMatrimonialFIR = data.caseType === 'Matrimonial';
  const [isLoading, setIsLoading] = useState(false);
  const [allegationsData, setAllegationsData] = useState(data.allegations ? data : null);
  const [maxImprisonment, setMaxImprisonment] = useState(data.maxImprisonmentInMonths || 0);
  const [corroborationData, setCorroborationData] = useState(data.allegationsAnalysed ? data : null);
  const [rightsData, setRightsData] = useState(data.rights ? data : null);
  const [investigationPoints, setInvestigationPoints] = useState(data.investigationPointsAnalysed ? data : null);
  const [evidencePoints, setEvidencePoints] = useState(data.evidencePointsAnalysed ? data : null);
  const [strategiesData, setStrategiesData] = useState(data.strategies ? data : null);

  const selectedUser = data ? data.user : '';
  const [errorMessage, setErrorMessage] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false);

  const [step, setStep] = useState(0);
  const [analysisButtonLabel, setAnalysisButtonLabel] = useState(null);
  const [isEndOfAnalysis, setIsEndOfAnalysis] = useState(false);
  const [oppositeAnalysisCompleted, setOppositeAnalysisCompleted] = useState(((data.iOfComplainantAndWitnesses && data.iOfComplainantAndWitnesses.responses) || (data.iOfAccusedAndWitnesses && data.iOfAccusedAndWitnesses.responses)) ? true : false);
  const [isLongAnalysis, setIsLongAnalysis] = useState(false);
  // const [isDownloadingPDF, setIsDownloadingPDF] = useState(false);
  // const firPageRef = useRef(null);

  //const [rateLater, setRateLater] = useState(false);
  const [showConfirmRatingPopup, setShowConfirmRatingPopup] = useState(false);
  const [ratingFor, setRatingFor] = useState(null);
  const [pendingRatings, setPendingRatings] = useState(null);
  const [recheckPendingRatings, setRecheckPendingRatings] = useState(false);

  const [showSelectApplicationPopup, setShowSelectApplicationPopup] = useState(false);

  const [userEmail, setUserEmail] = useState(localStorage.getItem('email') || null);

  useEffect(() => {
    if (data) {
      //console.log(data);
      //console.log(strategiesData);

      if (data.strategies) {
        setAnalysisButtonLabel(null);
        setIsEndOfAnalysis(true);
        setStep(6);
        return;
      } else if (data.evidencePointsAnalysed) {
        setAnalysisButtonLabel('Analyse Strategies');
        setStep(5);
        return;
      } else if (data.investigationPointsAnalysed) {
        if (data.investigationPointsAnalysed === 'Accused' || data.investigationPointsAnalysed === 'Defense Counsel') {
          setAnalysisButtonLabel('Analyse Defense Evidence');
        } else {
          setAnalysisButtonLabel('Analyse Supporting Evidence');
        }
        setStep(4);
        return;
      } else if (data.rights) {
        setAnalysisButtonLabel('Analyse FIR Investigation Points');
        setStep(3);
        return;
      } else if (data.allegationsAnalysed) {
        setAnalysisButtonLabel('Analyse Rights');
        setStep(2);
        return;
      } else if (data.allegations) {
        setAnalysisButtonLabel('Analyse Allegations');
        setStep(1);
        return;
      } else {
        setAnalysisButtonLabel('Extract Allegations');
        setStep(0);
        return;
      }
    }
  }, []);

  const errorOK = () => {
    setErrorMessage(null);
    if (sessionExpired) {
      navigate('/login');
    }
  }

  // const handleDownloadPDF = async () => {
  //   setIsDownloadingPDF(true);

  //   try {
  //     // Capture the content within the fir-page-to-download div
  //     const element = firPageRef.current;
  //     const canvas = await html2canvas(element, {
  //       scale: 2, // Increase scale for better resolution
  //       useCORS: true, // Enable cross-origin image loading if needed
  //     });
  //     const imageData = canvas.toDataURL('image/png');

  //     // Create a new PDF document using pdfMake
  //     const docDefinition = {
  //       content: [
  //         {
  //           image: imageData,
  //           width: 500,
  //         },
  //       ],
  //       // Add page numbers
  //       footer: function (currentPage, pageCount) {
  //         return { text: `Page ${currentPage} of ${pageCount}`, alignment: 'center' };
  //       },
  //     };

  //     // Generate the PDF
  //     pdfMake.createPdf(docDefinition).download(`FIR_Analysis_${data.id}.pdf`);
  //   } catch (error) {
  //     console.error('Error generating PDF:', error);
  //     setErrorMessage('Error generating PDF. Please try again later.');
  //   } finally {
  //     setIsDownloadingPDF(false);
  //   }
  // };


  const handlePrint = () => {
    // Add a style sheet to enforce minimum margins
    const style = document.createElement('style');
    style.innerHTML = `
    @page {
      margin-top: 5cm;
      margin-bottom: 1cm;
      margin-left: 1cm;
      margin-right: 1cm;
      scale: 0.9;
    }`;

    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };

  const checkRating = async () => {
    if (step === 3 && rightsData && rightsData.rights && rightsData.rights.length > 0) {
      //check all rights are rated or not
      const size = Object.keys(rightsData.rightRatingMap || {}).length;
      if (!rightsData.rightRatingMap || rightsData.rights.length !== size) {
        setRatingFor('Rights');
        setShowConfirmRatingPopup(true);
        return;
      } else {
        handleContinue();
        return;
      }
    } else if (step === 4) {
      //check all investigation points are rated or not
      if (investigationPoints && investigationPoints.allegations && investigationPoints.allegations.length > 0) {
        let allRated = true;
        investigationPoints.allegations.forEach(allegation => {
          if (!allegation.investigationQuestionsRating || allegation.investigationQuestionsRating === 0) {
            allRated = false;
          }
        });

        if (!allRated) {
          setRatingFor('Investigation Points');
          setShowConfirmRatingPopup(true);
          return;
        } else {
          handleContinue();
          return;
        }
      }
    } else if (step === 5) {
      //check all evidence points are rated or not
      if (evidencePoints && evidencePoints.allegations && evidencePoints.allegations.length > 0) {
        let allRated = true;
        evidencePoints.allegations.forEach(allegation => {
          if (evidencePoints.user === 'Accused' || evidencePoints.user === 'Defense Counsel') {
            if (!allegation.defensePointsRating || allegation.defensePointsRating === 0) {
              allRated = false;
            }
          } else {
            if (!allegation.prosecutionPointsRating || allegation.prosecutionPointsRating === 0) {
              allRated = false;
            }
          }
        });

        if (!allRated) {
          setRatingFor('Evidence Points');
          setShowConfirmRatingPopup(true);
          return;
        } else {
          handleContinue();
          return;
        }
      }
    }
  };

  useEffect(() => {
    if (isEndOfAnalysis) {
      checkPendingRatings();
    }
  }, [isEndOfAnalysis, recheckPendingRatings]);

  const checkPendingRatings = () => {
    //console.log("Checking pending ratings...");

    var pendingRatings = null;

    if (rightsData && rightsData.rights && rightsData.rights.length > 0) {
      //check all rights are rated or not
      const size = Object.keys(rightsData.rightRatingMap || {}).length;
      if (!rightsData.rightRatingMap || rightsData.rights.length !== size) {
        pendingRatings = "Rights";
      }
    }

    //check all investigation points are rated or not
    if (investigationPoints && investigationPoints.allegations && investigationPoints.allegations.length > 0) {
      let allRated = true;
      investigationPoints.allegations.forEach(allegation => {
        if (!allegation.investigationQuestionsRating || allegation.investigationQuestionsRating === 0) {
          allRated = false;
        }
      });

      if (!allRated) {
        if (pendingRatings) {
          pendingRatings += ", Investigation Points";
        } else {
          pendingRatings = "Investigation Points";
        }
      }
    }

    //check all evidence points are rated or not
    if (evidencePoints && evidencePoints.allegations && evidencePoints.allegations.length > 0) {
      let allRated = true;
      evidencePoints.allegations.forEach(allegation => {
        if (evidencePoints.user === 'Accused' || evidencePoints.user === 'Defense Counsel') {
          if (!allegation.defensePointsRating || allegation.defensePointsRating === 0) {
            allRated = false;
          }
        } else {
          if (!allegation.prosecutionPointsRating || allegation.prosecutionPointsRating === 0) {
            allRated = false;
          }
        }
      });

      if (!allRated) {
        if (pendingRatings) {
          pendingRatings += ", Evidences";
        } else {
          pendingRatings = "Evidences";
        }
      }
    }

    //check all strategies are rated or not
    if (strategiesData && strategiesData.strategies && strategiesData.strategies.length > 0) {
      //check all strategies are rated or not
      const size = Object.keys(strategiesData.strategyRatingMap || {}).length;
      if (!strategiesData.strategyRatingMap || strategiesData.strategies.length !== size) {
        if (pendingRatings) {
          pendingRatings += ", Strategies";
        } else {
          pendingRatings = "Strategies";
        }
      }
    }

    if (pendingRatings) {
      //if there are more than one pending ratings, add the word 'add' before the last
      if (pendingRatings.includes(",")) {
        const lastCommaIndex = pendingRatings.lastIndexOf(",");
        //count the number of , before lastCommaIndex
        let commaCount = 0;
        for (let i = 0; i < lastCommaIndex; i++) {
          if (pendingRatings[i] === ",") {
            commaCount++;
          }
        }

        if (commaCount > 0) {
          pendingRatings = pendingRatings.substring(0, lastCommaIndex) + ", and" + pendingRatings.substring(lastCommaIndex + 1);
        } else {
          pendingRatings = pendingRatings.substring(0, lastCommaIndex) + " and" + pendingRatings.substring(lastCommaIndex + 1);
        }
      }
      setPendingRatings(pendingRatings);
    }
  }

  const handleContinue = async () => {
    setIsLoading(true);
    setShowConfirmRatingPopup(false);

    var jwt = localStorage.getItem('jwtToken');

    try {
      if (step === 0) {
        //console.log(data);
        const response = await axios.get(API_URL + `/fir/allegations/${data.id}`, {
          headers: {
            'Authorization': `Bearer ${jwt}`,
          },
        });
        //console.log(response.data);
        setAllegationsData(response.data);
        // Extract the max imprisonment value from the allegations data
        const maxImprisonmentFromAPI = response.data.maxImprisonmentInMonths || 0;

        setMaxImprisonment(maxImprisonmentFromAPI);  // Update state
        setAnalysisButtonLabel('Analyse Allegations');
        setStep(1);
      } else if (step === 1) {
        //console.log(data);
        const response = await axios.get(API_URL + `/fir/corroborations/${data.id}`, {
          headers: {
            'Authorization': `Bearer ${jwt}`,
          },
        });
        //console.log(response.data);
        setCorroborationData(response.data);
        setAnalysisButtonLabel('Analyse Rights');
        setStep(2);
      } else if (step === 2) {
        //console.log(data);
        const response = await axios.get(API_URL + `/fir/rights/${data.id}`, {
          headers: {
            'Authorization': `Bearer ${jwt}`,
          },
        });
        //console.log(response.data);
        setRightsData(response.data);
        setAnalysisButtonLabel('Analyse FIR Investigation Points');
        setStep(3);
      } else if (step === 3) {
        //console.log(data);
        setIsLongAnalysis(true);
        const response = await axios.get(API_URL + `/fir/investigation/${data.id}`, {
          headers: {
            'Authorization': `Bearer ${jwt}`,
          },
        });
        //console.log(response.data);
        setInvestigationPoints(response.data);
        if (response.data.user === 'Accused' || response.data.user === 'Defense Counsel') {
          setAnalysisButtonLabel('Analyse Defense Evidence');
        } else {
          setAnalysisButtonLabel('Analyse Supporting Evidence');
        }

        setStep(4);
      } else if (step === 4) {
        //console.log(data);
        setIsLongAnalysis(true);
        const response = await axios.get(API_URL + `/fir/evidence/${data.id}`, {
          headers: {
            'Authorization': `Bearer ${jwt}`,
          },
        });
        //console.log(response.data);
        setEvidencePoints(response.data);
        setAnalysisButtonLabel('Analyse Strategies');
        setStep(5);
      } else if (step === 5) {
        //console.log(data);
        setIsLongAnalysis(false);
        const response = await axios.get(API_URL + `/fir/strategy/${data.id}`, {
          headers: {
            'Authorization': `Bearer ${jwt}`,
          },
        });
        //console.log(response.data.strategies);
        setStrategiesData(response.data);
        setAnalysisButtonLabel(null);
        setIsEndOfAnalysis(true);
        setStep(6);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        // Clear local storage and redirect to login
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('email');
        localStorage.removeItem('role');
        localStorage.removeItem('firstName');
        localStorage.removeItem('firList');
        setSessionExpired(true);
        setErrorMessage("Your session has expired. Please log in again.");
      } else {
        setErrorMessage("An error occurred while processing the request. Please try again later.");
      }
    } finally {
      setIsLoading(false);
      setIsLongAnalysis(false);
      localStorage.removeItem('firList');
    }
  };

  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  // Format seconds into MM:ss (e.g., 65 => "01:05")
  const formatElapsedTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const analyseInvestigationPointsForAllegation = async (allegationIndex) => {
    var jwt = localStorage.getItem('jwtToken');
    const response = await axios.get(API_URL + `/fir/investigation/${data.id}/${allegationIndex}`, {
      headers: {
        'Authorization': `Bearer ${jwt}`,
      },
    });
    //console.log(response.data);
    setInvestigationPoints(response.data);
  }

  const analyseDefenseForAllegation = async (allegationIndex) => {
    var jwt = localStorage.getItem('jwtToken');
    const response = await axios.get(API_URL + `/fir/evidence/${data.id}/${allegationIndex}`, {
      headers: {
        'Authorization': `Bearer ${jwt}`,
      },
    });
    //console.log(response.data);
    setEvidencePoints(response.data);
  }

  useEffect(() => {
    let timer;
    if (isLoading && isLongAnalysis) {
      timer = setInterval(() => {
        setElapsedSeconds(prev => prev + 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isLoading, isLongAnalysis]);

  useEffect(() => {
    if (!isLoading) {
      setElapsedSeconds(0);
    }
  }, [isLoading]);

  const confirmApplication = () => {
    setShowSelectApplicationPopup(true);
  }

  const [application, setApplication] = useState("pi_police");
  const [isApplicationLoading, setIsApplicationLoading] = useState(false);

  const handleApplicationChange = (e) => {
    setApplication(e.target.value);
  }

  const onConfirmApplication = async () => {
    setIsApplicationLoading(true);

    let uri = 'police';
    if (application === "pi_police") {
      uri = 'police';
    } else {
      uri = 'court';
    }

    try {
      const jwt = localStorage.getItem('jwtToken');
      const response = await axios.get(API_URL + `/fir/pi/${uri}/${data.id}`, {
        headers: {
          'Authorization': `Bearer ${jwt}`,
        },
        responseType: 'blob', // Important: This tells axios to expect a binary file
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], { type: 'application/rtf' });

      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link to trigger the download
      const link = document.createElement('a');
      link.href = url;
      if (uri === 'police') {
        link.download = `PI_PoliceApplication_${data.id}.rtf`; // You can customize the file name here
      } else if (uri === 'court') {
        link.download = `PI_CourtApplication_${data.id}.rtf`; // You can customize the file name here
      }

      link.style.display = 'none'; // Hide the link

      // Add the link to the DOM, click it, and then remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Revoke the temporary URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading FIR:', error);
      setErrorMessage("An error occurred while downloading the FIR. Please try again later.");
    } finally {
      setIsApplicationLoading(false);
      setShowSelectApplicationPopup(false);
    }
  };

  const [addAllegationPopupOpen, setAddAllegationPopupOpen] = useState(false);
  const [newAllegationText, setNewAllegationText] = useState('');
  const [newAllegationDescription, setNewAllegationDescription] = useState('');
  const [newAllegationAct, setNewAllegationAct] = useState('');
  const [newAllegationSection, setNewAllegationSection] = useState('');
  const [addingAllegation, setAddingAllegation] = useState(false);

  const handleNewAllegationTextChange = (e) => {
    setNewAllegationText(e.target.value);
  };

  const handleNewAllegationDescriptionChange = (e) => {
    setNewAllegationDescription(e.target.value);
  }

  const handleNewAllegationActChange = (e) => {
    setNewAllegationAct(e.target.value);
  };

  const handleNewAllegationSectionChange = (e) => {
    // discard , and spaced in the input
    e.target.value = e.target.value.replace(/,/g, '');
    // e.target.value = e.target.value.replace(/\s+/g, '');
    setNewAllegationSection(e.target.value);
  };

  const cancelAddAllegationPopup = () => {
    setAddAllegationPopupOpen(false);
    setNewAllegationText('');
    setNewAllegationDescription('');
    setNewAllegationAct('');
    setNewAllegationSection('');
  }

  const submitNewAllegation = async () => {
    setAddingAllegation(true);
    setErrorMessage(null);

    const newAllegation = {
      allegationVerbatim: newAllegationText,
      allegationSummary: newAllegationDescription,
      actAndSection: newAllegationAct + ' Section ' + newAllegationSection,
    };

    try {
      const jwt = localStorage.getItem('jwtToken');
      const response = await axios.post(API_URL + `/fir/allegations/add/${data.id}`, newAllegation, {
        headers: {
          'Authorization': `Bearer ${jwt}`,
          'Content-Type': 'application/json',
        },
      });

      console.log("New allegation added:", response.data);

      // Update the allegations data with the new allegation
      if (response.data.allegations) {
        setAllegationsData(response.data);
      }

      if (response.data.maxImprisonmentInMonths) {
        setMaxImprisonment(response.data.maxImprisonmentInMonths);
      }

      if (response.data.allegationsAnalysed) {
        setCorroborationData(response.data);
      }

      if (response.data.rights) {
        setRightsData(response.data);
      }

      if (response.data.investigationPointsAnalysed) {
        setInvestigationPoints(response.data);
      }

      if (response.data.evidencePointsAnalysed) {
        setEvidencePoints(response.data);
      }

      if (response.data.strategies) {
        setStrategiesData(response.data);
      }

      setAddAllegationPopupOpen(false);
      setNewAllegationText('');
      setNewAllegationDescription('');
      setNewAllegationAct('');
      setNewAllegationSection('');
      setAddingAllegation(false);

      localStorage.removeItem('firList'); // Clear the FIR list to avoid stale data
    } catch (error) {
      console.error("Error adding allegation:", error);
      setErrorMessage("Error processing request. Please try again later.");
    }
  }

  const oppositeParty = (data.user === 'Complainant' || data.user === 'Prosecution Counsel') ? 'Accused' : 'Complainant';
  const [confirmAnalysisForOppositeParty, setConfirmAnalysisForOppositeParty] = useState(false);
  const [isLoadingForOppositeParty, setIsLoadingForOppositeParty] = useState(false);

  const handleConfirmAnalysisForOppositeParty = async () => {
    setIsLoadingForOppositeParty(true);
    setErrorMessage(null);
    var jwt = localStorage.getItem('jwtToken');
    try {
      const response = await axios.get(API_URL + `/fir/opposite-party/${data.id}`, {
        headers: {
          'Authorization': `Bearer ${jwt}`,
        },
      });
      console.log("API Response:", response.data);
      if (response.data) {
        localStorage.removeItem('firList'); // Clear the FIR list to avoid stale data
        //Open the FIR page with the data for the opposite party
        // navigate('/fir', {
        //   state: {
        //     API_URL: API_URL,
        //     data: response.data,
        //   },
        // });
        navigate('/mycases');
        setIsLoadingForOppositeParty(false);
        return;
      }
    } catch (error) {
      console.error("Error fetching data for opposite party:", error);
      setIsLoadingForOppositeParty(false);
      //set error message
      setErrorMessage("An error occurred while processing the request. Please try again later.");
    }
  }

  const [isViewComplaintPopupOpen, setIsViewComplaintPopupOpen] = useState(false);
  const email = localStorage.getItem('email');

  return (
    <div className="fir-page-container">
      <Navbar />
      <main style={{ flex: 1 }}>
        <br></br><br></br>
        <div className="info-section" style={{ marginTop: '35px' }}>
          <center>
            <b>{(data.id === '0dkuEsSZ1Hs9xIMjMqCf' || data.id === 'y9z9xpAUJewPhl5JEfHD') ? 'Sample' : ''} FIR Analysis {selectedUser ? ' for ' + selectedUser : ''}</b>
            <br />
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>
              AI-generated. Verify the information before taking any action.
            </span>
          </center>
        </div>

        <div className="info-section">
          <center>
            <button
              className='submit-button'
              style={{ marginLeft: 'auto', backgroundColor: '#FFFFFF', color: '#094268', fontWeight: 'bold', border: '1px solid #094268' }}
              onClick={() => setIsViewComplaintPopupOpen(true)}>
              View Complaint
            </button>
          </center>
        </div>

        <div className="fir-page">
          <div className="info-section">
            <p><b>FIR Sections:</b></p>
          </div>
          <FIRSections sections={data.firSections || []} />

          <div className="info-section">
            <p><b>Complainant:</b></p>
          </div>
          <ComplainantTable complainant={data.complainant || {}} />

          <div className="info-section">
            <p><b>Accused Persons:</b></p>
          </div>
          <AccusedTable accusedList={data.accusedList || []} />

          <div className="info-section" >
            <p><b>Overview:</b></p>
          </div>
          <FIROverview data={{ ...data, maxImprisonmentInMonths: maxImprisonment }} />

          {allegationsData && (
            <>
              <div className="info-section" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div><b>Allegations:</b></div>
                <button className='submit-button' style={{ marginLeft: 'auto', fontWeight: 'bold' }} onClick={() => setAddAllegationPopupOpen(true)}>
                  Add Allegation
                </button>
              </div>
              <AllegationsTable allegations={allegationsData.allegations || []} user={data.user} />
            </>
          )}

          {corroborationData && (
            <>
              <div className="info-section">
                <p><b>Allegations Analysis:</b></p>
              </div>
              <CorroborationsTable
                API_URL={API_URL}
                id={data.id}
                allegations={corroborationData.allegations || []}
                user={data.user} />
            </>
          )}

          {data.email !== 'demo@legalapp.in' && rightsData && localStorage.getItem('role') !== 'police' && (
            <>
              <div className="info-section">
                {data.user && (data.user === 'Accused' || data.user === 'Defense Counsel') ?
                  <p><b>Legal Rights of Accused:</b></p>
                  :
                  <p><b>Legal Rights of Complainant:</b></p>
                }
              </div>
              <RightsTable
                API_URL={API_URL}
                id={data.id}
                bucketFileName={data.bucketFileName}
                rights={rightsData.rights || []}
                rightToAllegationsMap={rightsData.rightToAllegationsMap || {}}
                rightRatingMap={rightsData.rightRatingMap || {}}
                setRecheckPendingRatings={setRecheckPendingRatings}
              />
            </>
          )}

          {investigationPoints && (
            <>
              <div className="info-section">
                {data.user && (data.user === 'Accused' || data.user === 'Defense Counsel') ?
                  <p><b>FIR Investigation Points:</b></p>
                  :
                  <p><b>FIR Investigation Points:</b></p>
                }
              </div>
              <FIRInvestigationTable
                API_URL={API_URL}
                id={data.id}
                allegations={investigationPoints.allegations || []}
                user={data.user}
                setRecheckPendingRatings={setRecheckPendingRatings}
                analyseInvestigationPointsForAllegation={analyseInvestigationPointsForAllegation} />
              {/* <div style={{ height: '100px' }}></div> */}
            </>
          )}

          {evidencePoints && (
            <>
              <div className="info-section">
                {data.user && (data.user === 'Accused' || data.user === 'Defense Counsel') ?
                  <p><b>Evidence Mapping:</b></p>
                  :
                  <p><b>Evidence Mapping:</b></p>
                }
              </div>
              <FIREvidenceMappingTable
                API_URL={API_URL}
                id={data.id}
                allegations={evidencePoints.allegations || []}
                user={data.user}
                setRecheckPendingRatings={setRecheckPendingRatings}
                analyseDefenseForAllegation={analyseDefenseForAllegation} />
              {/* <div style={{ height: '100px' }}></div> */}
            </>
          )}

          {userEmail !== 'demo@legalapp.in' && strategiesData && localStorage.getItem('role') !== 'police' && (
            <>
              <div className="info-section">
                {data.user && (data.user === 'Accused' || data.user === 'Defense Counsel') ?
                  <p><b>Legal Strategy for Accused:</b></p>
                  :
                  <p><b>Legal Strategy for Complainant:</b></p>
                }
              </div>
              <StrategyTable
                API_URL={API_URL}
                id={data.id}
                bucketFileName={data.bucketFileName}
                strategies={strategiesData.strategies || []}
                strategyToAllegationsMap={strategiesData.strategyToAllegationsMap || {}}
                strategyRatingMap={strategiesData.strategyRatingMap || {}}
                setRecheckPendingRatings={setRecheckPendingRatings}
              />
            </>
          )}

          {data.iOfComplainantAndWitnesses && data.iOfComplainantAndWitnesses.responses && (
            <>
              <div className="info-section">
                <p><b>Interrogation Analysis (Complainant & Witnesses):</b></p>
              </div>
              {/* <AllegationCorroborationTable
                allegations={data.allegations}
                corroboratedAllegations={data.iOfComplainantAndWitnesses.corroboratedAllegationMap}
                uncorroboratedAllegations={data.iOfComplainantAndWitnesses.uncorroboratedAllegationMap} /> */}
              <InterrogationTable interrogationList={data.iOfComplainantAndWitnesses.responses} />
            </>
          )}

          {data.iOfComplainantAndWitnesses && data.iOfComplainantAndWitnesses.contradictions && (
            <div>
              <>
                <div className="info-section">
                  <p><b>Contradictions in statements of Complainant & Witnesses:</b></p>
                </div>
                <div>
                  {data.iOfComplainantAndWitnesses.contradictions.map((contradiction, idx) => {
                    // If it ends with a single '\n', add another
                    let text = contradiction.endsWith("\n") && !contradiction.endsWith("\n\n")
                      ? contradiction + "\n"
                      : contradiction;

                    return (
                      <div
                        key={idx}
                        style={{
                          border: "1px solid lightgrey",
                          borderRadius: "6px",
                          padding: "8px",
                          marginBottom: "8px",
                          backgroundColor: "#fafafa"
                        }}
                      >
                        {text.split("\n").map((line, i) =>
                          line.trim() ? (   // only render if not empty after trimming
                            <React.Fragment key={i}>
                              {line}
                              <br />
                            </React.Fragment>
                          ) : null
                        )}
                      </div>
                    );
                  })}
                </div>

              </>
            </div>
          )}

          {data.iOfComplainantAndWitnesses && data.iOfComplainantAndWitnesses.inconsistencies && (
            <div>
              <>
                <div className="info-section">
                  <p><b>Inconsistencies in Statements of Complainant & Witnesses:</b></p>
                </div>
                <div>
                  {data.iOfComplainantAndWitnesses.inconsistencies.map((inconsistency, idx) => {
                    // If it ends with a single '\n', add another
                    let text = inconsistency.endsWith("\n") && !inconsistency.endsWith("\n\n")
                      ? inconsistency + "\n"
                      : inconsistency;

                    return (
                      <div
                        key={idx}
                        style={{
                          border: "1px solid lightgrey",
                          borderRadius: "6px",
                          padding: "8px",
                          marginBottom: "8px",
                          backgroundColor: "#fafafa"
                        }}
                      >
                        {text.split("\n").map((line, i) =>
                          line.trim() ? (   // only render if not empty after trimming
                            <React.Fragment key={i}>
                              {line}
                              <br />
                            </React.Fragment>
                          ) : null
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            </div>
          )}

          {data.iOfAccusedAndWitnesses && data.iOfAccusedAndWitnesses.responses && (
            <>
              <div className="info-section">
                <p><b>Interrogation Analysis (Accused & Witnesses):</b></p>
              </div>
              <InterrogationTable interrogationList={data.iOfAccusedAndWitnesses.responses} />
            </>
          )}

          {data.iOfAccusedAndWitnesses && data.iOfAccusedAndWitnesses.contradictions && (
            <div>
              <>
                <div className="info-section">
                  <p><b>Contradictions in Statements of Accused & Witnesses:</b></p>
                </div>
                <div>
                  {data.iOfAccusedAndWitnesses.contradictions.map((contradiction, idx) => {
                    // If it ends with a single '\n', add another
                    let text = contradiction.endsWith("\n") && !contradiction.endsWith("\n\n")
                      ? contradiction + "\n"
                      : contradiction;

                    return (
                      <div
                        key={idx}
                        style={{
                          border: "1px solid lightgrey",
                          borderRadius: "6px",
                          padding: "8px",
                          marginBottom: "8px",
                          backgroundColor: "#fafafa"
                        }}
                      >
                        {text.split("\n").map((line, i) =>
                          line.trim() ? (   // only render if not empty after trimming
                            <React.Fragment key={i}>
                              {line}
                              <br />
                            </React.Fragment>
                          ) : null
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            </div>
          )}

          {data.iOfAccusedAndWitnesses && data.iOfAccusedAndWitnesses.inconsistencies && (
            <div>
              <>
                <div className="info-section">
                  <p><b>Inconsistencies in statements of Accused & Witnesses:</b></p>
                </div>
                <div>
                  {data.iOfAccusedAndWitnesses.inconsistencies.map((inconsistency, idx) => {
                    // If it ends with a single '\n', add another
                    let text = inconsistency.endsWith("\n") && !inconsistency.endsWith("\n\n")
                      ? inconsistency + "\n"
                      : inconsistency;

                    return (
                      <div
                        key={idx}
                        style={{
                          border: "1px solid lightgrey",
                          borderRadius: "6px",
                          padding: "8px",
                          marginBottom: "8px",
                          backgroundColor: "#fafafa"
                        }}
                      >
                        {text.split("\n").map((line, i) =>
                          line.trim() ? (   // only render if not empty after trimming
                            <React.Fragment key={i}>
                              {line}
                              <br />
                            </React.Fragment>
                          ) : null
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            </div>
          )}

          {data.iOfComplainantAndWitnesses && data.iOfComplainantAndWitnesses.responses && (
            <>
              <div className="info-section">
                <p><b>Corroboration Overview:</b></p>
              </div>
              <AllegationCorroborationTable
                allegations={data.allegations}
                corroboratedAllegations={data.iOfComplainantAndWitnesses.corroboratedAllegationMap}
                uncorroboratedAllegations={data.iOfComplainantAndWitnesses.uncorroboratedAllegationMap} />
            </>
          )}

          <div
            className="info-section"
            style={{
              display: 'flex', // Use Flexbox
              justifyContent: 'space-between', // Distribute space between columns
              alignItems: 'center', // Vertically center the buttons
              marginBottom: '10px',
              padding: '0 20px', // Add padding to prevent buttons from touching the edges
            }}
          >
            {/* Empty Column to Push First Button to Center */}
            <div style={{ flex: 1 }}>
              {(localStorage.getItem('role') === 'admin' || (data.id !== '0dkuEsSZ1Hs9xIMjMqCf' && data.id !== 'y9z9xpAUJewPhl5JEfHD')) && isEndOfAnalysis && pendingRatings && (
                <div className="info-section" style={{ fontSize: '15px' }}>
                  Please rate the <strong>{pendingRatings}</strong> to help us improve the AI.
                </div>
              )}
            </div>


            {/* First Button (Centered) */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
              {(!isEndOfAnalysis && isMatrimonialFIR) && (
                <button
                  onClick={step < 3 ? handleContinue : checkRating}
                  className="submit-button"
                  disabled={isLoading}
                  style={{
                    backgroundColor: '#4682B4',
                    padding: '10px 20px',
                    fontSize: '14px',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#36648B'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4682B4'}
                >
                  {isLoading ? (
                    <div className="spinner"></div>
                  ) : (
                    <>
                      <span>Next</span>
                      <span>→</span>
                      {analysisButtonLabel && <span>{analysisButtonLabel}</span>}
                    </>
                  )}
                </button>
              )}

              {/* {(localStorage.getItem('role') === 'admin' || data.id !== '0dkuEsSZ1Hs9xIMjMqCf' && data.id !== 'y9z9xpAUJewPhl5JEfHD') && isEndOfAnalysis && pendingRatings && (
                <div className="info-section" style={{ fontSize: '15px' }}>
                  Please rate the <strong>{pendingRatings}</strong> to help us improve the AI results.
                </div>
              )} */}

              {(localStorage.getItem('role') !== 'admin' && (data.id === '0dkuEsSZ1Hs9xIMjMqCf' || data.id === 'y9z9xpAUJewPhl5JEfHD')) && (
                <div className="info-section" style={{ fontSize: '18px', fontWeight: 'bold' }}>
                  <a
                    href='/upload'
                    style={{ color: '#094268', textDecoration: 'underline', textUnderlineOffset: '5px' }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/upload');
                    }}>
                    Analyse Your FIR to Unlock Full Results
                  </a>
                </div>
              )}
            </div>

            {/* Second Button (Right Aligned) */}

            {isMatrimonialFIR && (
              <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                {email !== 'demo@legalapp.in' && localStorage.getItem('role') !== 'police' && (
                  <button
                    onClick={confirmApplication}
                    disabled={isLoading || step < 4}
                    hidden={isLoading || !isMatrimonialFIR || email === 'demo@legalapp.in'}
                    className={`print-button ${isLoading ? 'hidden' : ''}`}
                    style={{ paddingRight: '20px', marginRight: '20px' }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      style={{ width: '20px', height: '20px', marginRight: '1px' }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 3v2.25m0 13.5V21m6.364-15.364l-1.591 1.591M4.636 18.364l1.591-1.591M21 12h-2.25m-13.5 0H3m15.364 6.364l-1.591-1.591M4.636 5.636l1.591 1.591M12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"
                      />
                    </svg>
                    Generate Application
                  </button>
                )}
                <button
                  onClick={handlePrint}
                  disabled={isLoading}
                  hidden={isLoading || !isMatrimonialFIR}
                  className={`print-button ${isLoading ? 'hidden' : ''}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    fill="currentColor"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z" />
                  </svg>
                  Print
                </button>
              </div>
            )}
          </div>


          {/* Additional Messages */}
          {(isLongAnalysis || !isMatrimonialFIR) && (
            <div style={{ textAlign: 'center', marginBottom: '150px' }}>
              <p style={{ fontSize: '16px' }} hidden={!isLoading}>
                <strong>
                  {isLongAnalysis ? (
                    <>
                      Please wait. AI Agent is carefully analyzing FIR - this may take a{' '}
                      <span style={{ textDecoration: 'underline' }}>few minutes</span> depending on the complexity and number of allegations involved.{' '}
                      <span style={{ fontWeight: 'bold', color: '#333' }}>
                        ({formatElapsedTime(elapsedSeconds)} mins)
                      </span>
                    </>
                  ) : (
                    "Please wait. AI Agent is carefully analyzing your case - this may take about a minute depending on the number of allegations involved."
                  )}
                </strong>
              </p>
              <p style={{ fontSize: '18px', fontWeight: 'bold', color: 'red' }} hidden={isMatrimonialFIR}>
                The current release supports analysis of matrimonial FIR (Police Complaint) only.
              </p>
            </div>
          )}

          {isEndOfAnalysis && !oppositeAnalysisCompleted && (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              <button
                // open Confirmation popup to confirm analysis for opposite party
                onClick={() => {
                  setConfirmAnalysisForOppositeParty(true);
                }}
                disabled={isLoading}
                hidden={isLoading || !isMatrimonialFIR}
                className={`submit-button ${isLoading ? 'hidden' : ''}`}
                style={{ marginLeft: '10px', fontWeight: 'bold', padding: '10px 20px' }}
              >
                Analyse FIR for {oppositeParty}
              </button>
            </div>
          )}

          {(!isLongAnalysis && isMatrimonialFIR) && (
            <div style={{ textAlign: 'center', color: '#094268', fontSize: '16px', fontStyle: 'normal', padding: '5px', borderRadius: '5px', lineHeight: '1.4', marginTop: '30px', marginBottom: '100px' }}>
              <strong>For assistance, email us at contact@legalapp.in.</strong>
            </div>
          )}

          <div style={{ textAlign: 'center', marginBottom: '50px' }}>
            <p style={{ fontSize: '16px' }}></p>
          </div>

        </div>

        {showConfirmRatingPopup && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h3>We Value Your Feedback!</h3>
              <p>Your feedback helps us improve the AI results for you.</p>
              {/* <p>Would you like to rate the {ratingFor} now? It will only take a moment!</p> */}
              <p>Would you like to rate the <strong>{ratingFor}</strong> now or proceed to the next analysis and rate them later?</p>
              <div className="popup-buttons">
                <button
                  className="submit-popup-button"
                  onClick={() => {
                    setShowConfirmRatingPopup(false);
                  }
                  }>Rate Now</button>
                <button
                  className="proceed-popup-button"
                  onClick={handleContinue}>
                  Rate Later</button>
              </div>
            </div>
          </div>
        )}

        {isViewComplaintPopupOpen && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h3>Complaint Details</h3>
              <div style={{ fontSize: '16px', alignContent: 'justify', alignItems: 'justify', textAlign: 'justify', maxHeight: '50vh', overflowY: 'auto', marginBottom: '16px' }}>
                <p>{data.firText.split('\n').map((line, index) => (
                  <span key={index}>
                    {line}
                    <br />
                  </span>
                ))}</p>
              </div>
              <div className="popup-buttons">
                <button
                  className="submit-popup-button"
                  onClick={() => {
                    setIsViewComplaintPopupOpen(false);
                  }
                  }>Close</button>
              </div>
            </div>
          </div>
        )}

        {addAllegationPopupOpen && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h3>Add Allegation</h3>

              {/* Field A - Full width */}
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', textAlign: 'left' }}>Allegation Text from FIR</label>
                <input
                  type="text"
                  placeholder="Enter FIR text"
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxSizing: 'border-box',
                    fontSize: '14px'
                  }}
                  value={newAllegationText}
                  onChange={handleNewAllegationTextChange}
                />
              </div>

              {/* Field B - Full width */}
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', textAlign: 'left' }}>Short Description</label>
                <input
                  type="text"
                  placeholder="Enter short description"
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxSizing: 'border-box',
                    fontSize: '14px'
                  }}
                  value={newAllegationDescription}
                  onChange={handleNewAllegationDescriptionChange}
                />
              </div>

              {/* Fields C and D - On same line */}
              <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                <div style={{ flex: 2 }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', textAlign: 'left' }}>Select Act</label>
                  <select style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxSizing: 'border-box',
                    fontSize: '14px',
                    height: '39px',
                  }}
                    value={newAllegationAct}
                    onChange={handleNewAllegationActChange}>
                    <option value="">Select Act</option>
                    <option value="IPC">Indian Penal Code (IPC)</option>
                    <option value="BNS">Bharatiya Nyaya Sanhita (BNS)</option>
                    <option value="Dowry Prohibition Act">Dowry Prohibition Act (DP Act)</option>
                  </select>
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', textAlign: 'left' }}>Section</label>
                  <input
                    type="text"
                    placeholder="Enter section"
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      boxSizing: 'border-box',
                      fontSize: '14px'
                    }}
                    value={newAllegationSection}
                    onChange={handleNewAllegationSectionChange}
                  />
                </div>
              </div>
              <div className="popup-buttons">
                <button
                  className="cancel-button"
                  // disabled={addingAllegation}
                  onClick={() => {
                    cancelAddAllegationPopup();
                  }
                  }>Cancel</button>
                <button
                  className="submit-popup-button"
                  disabled={!newAllegationText || !newAllegationDescription || !newAllegationAct || !newAllegationSection || addingAllegation}
                  onClick={() => {
                    submitNewAllegation();
                  }}>
                  {addingAllegation ? <div className="spinner"></div> : 'Submit'}</button>
              </div>
              {addingAllegation && (
                <p style={{ fontSize: '16px' }}>
                  <strong>
                    Please wait. It may take about a minute to update the analysis with the new allegation.
                  </strong>
                </p>
              )}
            </div>
          </div>
        )}

        {errorMessage && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Error</h2>
              <p>{errorMessage}</p>
              <div className="popup-buttons">
                <button
                  className="submit-popup-button"
                  onClick={errorOK}
                >Close</button>
              </div>
            </div>
          </div>
        )}

        {confirmAnalysisForOppositeParty && !errorMessage && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h3>Confirm Request</h3>
              <p>Do you want to analyze the FIR for {oppositeParty}?</p>
              <div className="popup-buttons">
                <button
                  className="cancel-button"
                  onClick={() => {
                    setConfirmAnalysisForOppositeParty(false);
                  }}>Cancel</button>
                <button
                  className="submit-popup-button"
                  onClick={handleConfirmAnalysisForOppositeParty}
                  disabled={isLoadingForOppositeParty}
                >
                  {isLoadingForOppositeParty ? <div className="spinner"></div> : 'Yes'}
                </button>
              </div>
            </div>
          </div>
        )}

        {sessionExpired && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Session Expired</h2>
              <p>Your session has expired. Please log in again.</p>
              <div className="popup-buttons">
                <button
                  className="submit-popup-button"
                  onClick={errorOK}
                >Close</button>
              </div>
            </div>
          </div>
        )}

        {showSelectApplicationPopup && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h3>Generate Application</h3>
              <h4 style={{ textAlign: 'left', marginBottom: '5px' }}>Select the Application:</h4>
              <select className="upload-select" onChange={handleApplicationChange} value={application}>
                <option value="pi_police">Application for Proper Investigation to Police</option>
                <option value="pi_magistrate">Application for Proper Investigation to Magistrate</option>
              </select>
              <div className="popup-buttons">
                <button
                  className="cancel-button"
                  disabled={isApplicationLoading}
                  onClick={() => {
                    setShowSelectApplicationPopup(false);
                  }
                  }>Cancel</button>
                <button
                  className="submit-popup-button"
                  onClick={onConfirmApplication}>
                  {isApplicationLoading ? (
                    <div className="spinner"></div>
                  ) : 'Submit'
                  }
                </button>
              </div>
              {isApplicationLoading && (
                <p style={{ fontSize: '16px' }}>
                  <strong>
                    Please wait. Generating application - this may take a few minutes.
                  </strong>
                </p>
              )}
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div >
  );
};

export default FIR;